import './styles.css';
import {
  CARS,
  COSMETIC_SLOTS,
  MAPS,
  RUPTURE_MAPS,
  getCar,
  getBotDifficulty,
  getMap,
  getRuptureMap,
} from './game/data.js';
import {
  equipCosmetic,
  getCarLoadout,
  getOwnedCatalog,
  loadGarage,
  saveGarage,
} from './game/garage.js';
import { InputManager } from './game/physics.js';
import { GameAudio } from './game/audio.js';
import { ToyboxGame } from './game/game.js';
import { OnlineClient } from './game/onlineClient.js';
import { getImportedVehicleCollider } from './game/carFactory.js';
import { networkColliderFor } from './game/networkSimulation.js';
import { EdgegapMatchmakingClient } from './game/edgegapMatchmakingClient.js';
import { loadPublishedCatalog } from './game/catalogRuntime.js';
import { PlayerAccount } from './game/playerAccount.js';
import { TrailerDirector } from './game/trailerDirector.js';
import {
  getEffectiveGraphicsSettings,
  keyCodeLabel,
  loadGameSettings,
  resetGameSettings,
  saveGameSettings,
} from './game/settings.js';
import {installGameI18n} from './i18n.js';
import { POWERUP_DEFINITIONS } from './game/powerups.js';
import {
  ONLINE_BOT_APPEARANCE_LIMIT,
  createBotAppearanceDeck,
} from './game/botAppearance.js';

const $ = (selector) => document.querySelector(selector);

function safeHtml(value){
  return String(value??'').replace(/[&<>'"]/g,(character)=>({
    '&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;',
  })[character]);
}

function thumbnailImage(url,alt=''){
  if(!url)return '';
  return `<img src="${safeHtml(url)}" alt="${safeHtml(alt)}" loading="lazy" decoding="async" />`;
}

const elements = {
  canvas: $('#game-canvas'),
  gamepadFocusRing: $('#gamepad-focus-ring'),
  gamepadHints: $('#gamepad-hints'),
  virtualKeyboard: $('#virtual-keyboard'),
  virtualKeyboardTitle: $('#virtual-keyboard-title'),
  virtualKeyboardLabel: $('#virtual-keyboard-label'),
  virtualKeyboardValue: $('#virtual-keyboard-value'),
  virtualKeyboardKeys: $('#virtual-keyboard-keys'),
  virtualKeyboardCancel: $('#virtual-keyboard-cancel'),
  virtualKeyboardDone: $('#virtual-keyboard-done'),
  loading: $('#loading-screen'),
  menu: $('#menu-screen'),
  localScreen: $('#local-screen'),
  localButton: $('#local-button'),
  localBack: $('#local-back'),
  localModeList: $('#local-mode-list'),
  localBotDifficulty: $('#local-bot-difficulty'),
  localStart: $('#local-start'),
  localSelectionSummary: $('#local-selection-summary'),
  localMapTitle: $('#local-map-title'),
  localPlayerName: $('#local-player-name'),
  garageScreen: $('#garage-screen'),
  hud: $('#hud'),
  pause: $('#pause-screen'),
  startCountdown: $('#start-countdown'),
  startCountdownValue: $('#start-countdown-value'),
  postMatch: $('#post-match-screen'),
  postMatchTitle: $('#post-match-title'),
  pauseEyebrow: $('#pause-eyebrow'),
  pauseTitle: $('#pause-title'),
  pauseCopy: $('#pause-copy'),
  carList: $('#car-list'),
  mapList: $('#map-list'),
  practiceButton: $('#practice-button'),
  tutorialButton: $('#tutorial-button'),
  onlineButton: $('#online-button'),
  onlineScreen: $('#online-screen'),
  onlineBack: $('#online-back'),
  onlineConnection: $('#online-connection'),
  onlineConnectionDetail: $('#online-connection-detail'),
  onlineStatusCopy: $('#online-status-copy'),
  onlinePlayerName: $('#online-player-name'),
  onlineServerUrl: $('#online-server-url'),
  onlineConnect: $('#online-connect'),
  onlineMode: $('#online-mode'),
  onlineMap: $('#online-map'),
  onlineBotDifficulty: $('#online-bot-difficulty'),
  onlineEntry: $('#online-entry'),
  onlineQuickMatch: $('#online-quick-match'),
  onlineCreateRoom: $('#online-create-room'),
  onlineRoomCodeInput: $('#online-room-code-input'),
  onlineJoinRoom: $('#online-join-room'),
  onlineLobby: $('#online-lobby'),
  onlineRoomCode: $('#online-room-code'),
  onlineRoomCapacity: $('#online-room-capacity'),
  onlineCopyCode: $('#online-copy-code'),
  onlinePlayerList: $('#online-player-list'),
  onlineMatchNotice: $('#online-match-notice'),
  onlineMatchCopy: $('#online-match-copy'),
  onlineLeaveRoom: $('#online-leave-room'),
  onlineReady: $('#online-ready'),
  onlineStartMatch: $('#online-start-match'),
  onlineError: $('#online-error'),
  pauseButton: $('#pause-button'),
  tutorialGuide: $('#tutorial-guide'),
  tutorialStepCount: $('#tutorial-step-count'),
  tutorialStepIcon: $('#tutorial-step-icon'),
  tutorialStepLabel: $('#tutorial-step-label'),
  tutorialStepTitle: $('#tutorial-step-title'),
  tutorialStepCopy: $('#tutorial-step-copy'),
  tutorialProgressBar: $('#tutorial-progress-bar'),
  tutorialInputs: $('#tutorial-inputs'),
  tutorialKeyboardControl: $('#tutorial-keyboard-control'),
  tutorialGamepadControl: $('#tutorial-gamepad-control'),
  tutorialCompleteCopy: $('#tutorial-complete-copy'),
  controlsHelp:$('#controls-help'),
  controlsDriveKey: $('#controls-drive-key'),
  controlsJumpKey: $('#controls-jump-key'),
  controlsBoostKey: $('#controls-boost-key'),
  settingsAirNitroKey:$('#settings-air-nitro-key'),
  controlsHandbrakeKey: $('#controls-handbrake-key'),
  controlsFireKey: $('#controls-fire-key'),
  controlsStabilizeKey:$('#controls-stabilize-key'),
  controlsPowerupKey:$('#controls-powerup-key'),
  controlsCameraDistanceKey:$('#controls-camera-distance-key'),
  resumeButton: $('#resume-button'),
  pauseSettingsButton: $('#pause-settings-button'),
  restartButton: $('#restart-button'),
  backMenuButton: $('#back-menu-button'),
  mapNameHud: $('#map-name-hud'),
  combatReticle:$('#combat-reticle'),
  combatReticleLabel:$('#combat-reticle-label'),
  onlineNetwork: $('#online-network'),
  onlineNetworkPing: $('#online-network-ping'),
  onlineNetworkLoss: $('#online-network-loss'),
  nitroBar: $('#nitro-bar'),
  nitroPercent: $('#nitro-percent'),
  powerupSlot:$('#powerup-slot'),
  powerupSymbol:$('#powerup-symbol'),
  powerupName:$('#powerup-name'),
  powerupHint:$('#powerup-hint'),
  healthBar: $('#health-bar'),
  healthPercent: $('#health-percent'),
  testKoButton: $('#test-ko-button'),
  speedValue: $('#speed-value'),
  gearValue: $('#gear-value'),
  airBadge: $('#air-badge'),
  airState:$('#air-state'),
  airTime: $('#air-time'),
  messageToast: $('#message-toast'),
  minimap: $('#minimap'),
  soundButton: $('#sound-button'),
  fullscreenButton: $('#fullscreen-button'),
  quitButton: $('#quit-button'),
  settingsButton: $('#settings-button'),
  settingsScreen: $('#settings-screen'),
  settingsBack: $('#settings-back'),
  settingsDone: $('#settings-done'),
  settingsMasterVolume: $('#settings-master-volume'),
  settingsMasterValue: $('#settings-master-value'),
  settingsMusicVolume: $('#settings-music-volume'),
  settingsMusicValue: $('#settings-music-value'),
  settingsEffectsVolume: $('#settings-effects-volume'),
  settingsEffectsValue: $('#settings-effects-value'),
  settingsKeyBindings: $('#settings-key-bindings'),
  settingsBindingMessage: $('#settings-binding-message'),
  settingsLanguage: $('#settings-language'),
  settingsFullscreen: $('#settings-fullscreen'),
  settingsGraphicsPreset:$('#settings-graphics-preset'),
  settingsGraphicsSummary:$('#settings-graphics-summary'),
  settingsRenderScale:$('#settings-render-scale'),
  settingsRenderScaleValue:$('#settings-render-scale-value'),
  settingsShadowQuality:$('#settings-shadow-quality'),
  settingsParticleQuality:$('#settings-particle-quality'),
  settingsFpsLimit:$('#settings-fps-limit'),
  settingsShowFps:$('#settings-show-fps'),
  graphicsFpsCounter:$('#graphics-fps-counter'),
  settingsCameraShake: $('#settings-camera-shake'),
  settingsCameraShakeValue: $('#settings-camera-shake-value'),
  settingsControllerVibration: $('#settings-controller-vibration'),
  settingsControllerVibrationStrength: $('#settings-controller-vibration-strength'),
  settingsControllerVibrationStrengthValue: $('#settings-controller-vibration-strength-value'),
  settingsMouseSensitivity:$('#settings-mouse-sensitivity'),
  settingsMouseSensitivityValue:$('#settings-mouse-sensitivity-value'),
  settingsInvertMouseY:$('#settings-invert-mouse-y'),
  settingsControllerAimSensitivity:$('#settings-controller-aim-sensitivity'),
  settingsControllerAimSensitivityValue:$('#settings-controller-aim-sensitivity-value'),
  settingsMouseFire:$('#settings-mouse-fire'),
  settingsMouseCameraControl:$('#settings-mouse-camera-control'),
  settingsMouseCameraReverse:$('#settings-mouse-camera-reverse'),
  settingsReset: $('#settings-reset'),
  accountButton: $('#account-button'),
  accountButtonName: $('#account-button-name'),
  accountButtonStatus: $('#account-button-status'),
  accountScreen: $('#account-screen'),
  accountBack: $('#account-back'),
  accountCloudState: $('#account-cloud-state'),
  accountGuestPanel: $('#account-guest-panel'),
  accountUserPanel: $('#account-user-panel'),
  accountLoginTab: $('#account-login-tab'),
  accountRegisterTab: $('#account-register-tab'),
  accountLoginForm: $('#account-login-form'),
  accountRegisterForm: $('#account-register-form'),
  accountLoginEmail: $('#account-login-email'),
  accountLoginPassword: $('#account-login-password'),
  accountRegisterName: $('#account-register-name'),
  accountRegisterEmail: $('#account-register-email'),
  accountRegisterPassword: $('#account-register-password'),
  accountRegisterConfirm: $('#account-register-confirm'),
  accountSignIn: $('#account-sign-in'),
  accountSignUp: $('#account-sign-up'),
  accountContinueGuest: $('#account-continue-guest'),
  accountUserEmail: $('#account-user-email'),
  accountUserName: $('#account-user-name'),
  accountDisplayName: $('#account-display-name'),
  accountSaveProfile: $('#account-save-profile'),
  accountSyncNow: $('#account-sync-now'),
  accountSignOut: $('#account-sign-out'),
  accountMessage: $('#account-message'),
  garageOpen: $('#garage-open'),
  garageClose: $('#garage-close'),
  garageSearch: $('#garage-search'),
  garageOwnedCount: $('#garage-owned-count'),
  garageWallet: $('#garage-wallet'),
  garageCarClass: $('#garage-car-class'),
  garageCarName: $('#garage-car-name'),
  garageCarDescription: $('#garage-car-description'),
  garageLoadoutStatus: $('#garage-loadout-status'),
  garagePreview: $('#garage-preview'),
  garagePreviewTitle: $('#garage-preview-title'),
  garagePreviewDescription: $('#garage-preview-description'),
  chaseButton: $('#chase-button'),
  battleButton: $('#battle-button'),
  ffaButton: $('#ffa-button'),
  chaseHud: $('#chase-hud'),
  chaseTime: $('#chase-time'),
  chaseTarget: $('#chase-target'),
  chaseScoreboard: $('#chase-scoreboard'),
  chasePressure: $('#chase-pressure'),
  chasePressureLabel: $('#chase-pressure-label'),
  chasePressureBar: $('#chase-pressure-bar'),
  chasePressureStatus: $('#chase-pressure-status'),
  battleHud: $('#battle-hud'),
  battleTime: $('#battle-time'),
  battleBlueScore: $('#battle-blue-score'),
  battleRedScore: $('#battle-red-score'),
  ffaHud: $('#ffa-hud'),
  ffaTime: $('#ffa-time'),
  ffaRank: $('#ffa-rank'),
  ffaKills: $('#ffa-kills'),
  ffaScoreboard: $('#ffa-scoreboard'),
  ruptureHud: $('#rupture-hud'),
  rupturePhase: $('#rupture-phase'),
  ruptureTime: $('#rupture-time'),
  ruptureFuses: $('#rupture-fuses'),
  rupturePlatform: $('#rupture-platform'),
  ruptureProgressBar: $('#rupture-progress-bar'),
  ruptureSurvivors: $('#rupture-survivors'),
  ruptureDirection: $('#rupture-direction'),
  ruptureDirectionAlert: $('#rupture-direction-alert'),
  ruptureDirectionArrow: $('#rupture-direction-arrow'),
  ruptureDirectionCopy: $('#rupture-direction-copy'),
  modeLabel: $('#mode-label'),
  objectiveText: $('#objective-text'),
  healthLabelText: $('#health-label-text'),
  results: $('#results-screen'),
  resultsEyebrow: $('#results-eyebrow'),
  resultsTitle: $('#results-title'),
  resultsCopy: $('#results-copy'),
  resultsScoreboard: $('#results-scoreboard'),
  resultsRestart: $('#results-restart'),
  resultsMenu: $('#results-menu'),
  exitConfirmation: $('#exit-confirmation'),
  exitConfirmTitle: $('#exit-confirm-title'),
  exitConfirmCopy: $('#exit-confirm-copy'),
  exitConfirmCancel: $('#exit-confirm-cancel'),
  exitConfirmAccept: $('#exit-confirm-accept'),
  cosmeticTabs: $('#cosmetic-tabs'),
  cosmeticList: $('#cosmetic-list'),
  cosmeticDetailIcon: $('#cosmetic-detail-icon'),
  cosmeticDetailName: $('#cosmetic-detail-name'),
  cosmeticDetailDescription: $('#cosmetic-detail-description'),
  cosmeticDetailStatus: $('#cosmetic-detail-status'),
  purchaseConfirmation: $('#purchase-confirmation'),
  purchaseConfirmTitle: $('#purchase-confirm-title'),
  purchaseConfirmCopy: $('#purchase-confirm-copy'),
  purchaseConfirmIcon: $('#purchase-confirm-icon'),
  purchaseConfirmPrice: $('#purchase-confirm-price'),
  purchaseConfirmMessage: $('#purchase-confirm-message'),
  purchaseConfirmAccept: $('#purchase-confirm-accept'),
  purchaseConfirmCancel: $('#purchase-confirm-cancel'),
};

let settings = loadGameSettings(localStorage);
const i18n=installGameI18n(settings.language);

const publishedCatalog=await loadPublishedCatalog();
if(publishedCatalog.blocked){
  const loadingCopy=elements.loading.querySelector('p');
  const loadingTrack=elements.loading.querySelector('.loading-track');
  if(loadingTrack)loadingTrack.hidden=true;
  if(loadingCopy){
    loadingCopy.textContent=`CATÁLOGO NO DISPONIBLE · ${publishedCatalog.error}`;
  }
  throw new Error(publishedCatalog.error);
}

const garage = loadGarage(localStorage);
const storedCarId = localStorage.getItem('toybox-car') || 'muscle';
let guestGarage=garage;
let guestSelectedCarId=garage.ownedCars.includes(storedCarId) ? storedCarId : garage.ownedCars[0];
const state = {
  garage,
  carId: guestSelectedCarId,
  mapId: localStorage.getItem('toybox-map') || 'living',
  ruptureMapId: localStorage.getItem('toybox-rupture-map') || RUPTURE_MAPS[0].id,
  localMode: localStorage.getItem('toybox-local-mode') || 'chase',
  botDifficulty: getBotDifficulty(localStorage.getItem('toybox-bot-difficulty')).id,
  muted: localStorage.getItem('toybox-muted') === 'true',
  localOpen: false,
  garageOpen: false,
  onlineOpen: false,
  accountOpen: false,
  settingsOpen: false,
  exitConfirmOpen: false,
  purchaseOpen:false,
  cosmeticSlot: 'wheelId',
};

const input = new InputManager(window);
input.setPointerElement(elements.canvas);
const audio = new GameAudio();
input.setBindings(settings.controls);
input.setAimSettings({...settings.gameplay,mouse:settings.mouse});
input.setHaptics({
  enabled:settings.gameplay.controllerVibration,
  strength:settings.gameplay.controllerVibrationStrength/100,
});
audio.setVolumes({
  master:settings.audio.master/100,
  music:settings.audio.music/100,
  effects:settings.audio.effects/100,
});
let stuntTimer = 0;
let gamepadNavigationActive=false;
let gamepadFocusedElement=null;
let gamepadHintContext='';
let interfaceInputDevice='keyboard-mouse';
let keyboardNavigationActive=false;
let virtualKeyboardState=null;
let accountAuthMode='login';
let confirmedExitAction=null;
let exitConfirmReturnFocus=null;
let pendingPurchase=null;
let settingsReturnContext='menu';
let capturingBindingAction=null;

const game = new ToyboxGame(elements.canvas, input, audio, {
  onFps:(fps)=>{elements.graphicsFpsCounter.textContent=`${fps} FPS`;},
  onStart: (match) => {
    elements.menu.classList.add('hidden');
    elements.localScreen.classList.add('hidden');
    elements.garageScreen.classList.add('hidden');
    elements.onlineScreen.classList.add('hidden');
    elements.accountScreen.classList.add('hidden');
    elements.settingsScreen.classList.add('hidden');
    state.localOpen = false;
    state.garageOpen = false;
    state.onlineOpen = false;
    state.accountOpen = false;
    state.settingsOpen = false;
    elements.pause.classList.add('hidden');
    elements.results.classList.add('hidden');
    elements.postMatch.classList.add('hidden');
    elements.exitConfirmation.classList.add('hidden');
    elements.virtualKeyboard.classList.add('hidden');
    state.exitConfirmOpen=false;
    virtualKeyboardState=null;
    confirmedExitAction=null;
    exitConfirmReturnFocus=null;
    elements.hud.classList.remove('hidden');
    const onlineMatch=Boolean(match.online);
    elements.onlineNetwork.classList.toggle('hidden',!onlineMatch);
    const chasing=match.type==='chase';
    const battling=match.type==='battle';
    const freeForAll=match.type==='ffa';
    const rupture=match.type==='rupture';
    const tutorial=match.type==='tutorial';
    elements.hud.classList.toggle('chase-mode',chasing);
    elements.hud.classList.toggle('battle-mode',battling);
    elements.hud.classList.toggle('ffa-mode',freeForAll);
    elements.hud.classList.toggle('rupture-mode',rupture);
    elements.hud.classList.toggle('tutorial-mode',tutorial);
    elements.chaseHud.classList.toggle('hidden',!chasing);
    elements.battleHud.classList.toggle('hidden',!battling);
    elements.ffaHud.classList.toggle('hidden',!freeForAll);
    elements.ruptureHud.classList.toggle('hidden',!rupture);
    elements.tutorialGuide.classList.toggle('hidden',!tutorial);
    elements.hud.classList.remove('rupture-route-active');
    elements.ruptureDirection.classList.add('hidden');
    const practice=!onlineMatch&&match.type==='practice';
    elements.controlsHelp.classList.toggle('hidden',!practice&&!tutorial);
    elements.testKoButton.classList.toggle('hidden',!practice);
    elements.modeLabel.textContent=onlineMatch?`ONLINE · ${ONLINE_MODE_NAMES[match.onlineMode]||'PARTIDA'}`
      :tutorial?'ESCUELA TURBO':rupture?'RUPTURA TURBO':chasing?'PERSECUCIÓN':battling?'BATALLA 5 VS 5':freeForAll?'TODOS CONTRA TODOS':'PRÁCTICA LIBRE';
    elements.objectiveText.textContent=onlineMatch
      ?rupture?'SOBREVIVÍ A LOS SALTOS Y DERRUMBES · ARENA AUTORITATIVA ONLINE'
        :freeForAll?'ELIMINÁ A TODOS · COMBATE AUTORITATIVO ONLINE'
        :battling?'DESTRUÍ AL EQUIPO RIVAL · COMBATE AUTORITATIVO ONLINE'
          :'ALCANZÁ, CHOCÁ Y USA TUS DISPAROS TÁCTICAMENTE'
      :tutorial?'COMPLETÁ LAS LECCIONES Y CONSEGUÍ TU LICENCIA TURBO'
      :rupture?'PELEÁ · SALTÁ · ATERRIZÁ · EL PISO NO ESPERA'
      :chasing?'ALCANZÁ Y CHOCÁ AL AUTO PERSEGUIDO'
      :battling?'DESTRUÍ AL EQUIPO ROJO · PRIMERO A 15'
        :freeForAll?'ELIMINÁ A TODOS · PRIMERO A 15':'EXPLORÁ, COMBATÍ Y PROBÁ TUS COSMÉTICOS';
    elements.mapNameHud.textContent = rupture
      ?getRuptureMap(state.ruptureMapId).shortName
      :getMap(state.mapId).shortName;
  },
  onPause: (paused,{online:onlinePause=false}={}) => {
    elements.pause.classList.toggle('hidden',!paused);
    if(!paused)return;
    const tutorialPause=!onlinePause&&game.gameType==='tutorial';
    elements.pauseEyebrow.textContent=onlinePause?'PARTIDA ONLINE':tutorialPause?'ESCUELA TURBO':'JUEGO EN PAUSA';
    elements.pauseTitle.textContent=onlinePause?'Menú de partida':tutorialPause?'Lección en pausa':'Tomate un respiro';
    elements.pauseCopy.textContent=onlinePause
      ?'La partida continúa para los demás. Tu auto queda sin controles hasta que vuelvas.'
      :tutorialPause?'Tu progreso queda guardado mientras decidís cómo continuar.'
        :'Los juguetes se quedan exactamente donde los dejaste.';
    elements.restartButton.classList.toggle('hidden',onlinePause);
    elements.backMenuButton.textContent=onlinePause?'SALIR DE LA SALA':tutorialPause?'VOLVER AL INICIO':'VOLVER AL GARAGE';
    requestAnimationFrame(()=>focusInterfaceElement(elements.resumeButton));
  },
  onCountdown: (value,visible) => {
    elements.startCountdown.classList.toggle('hidden',!visible);
    if(!visible)return;
    elements.startCountdownValue.textContent=value;
    elements.startCountdown.classList.toggle('go',value==='¡YA!');
    elements.startCountdown.classList.remove('tick');
    void elements.startCountdown.offsetWidth;
    elements.startCountdown.classList.add('tick');
  },
  onMenu: () => {
    elements.hud.classList.add('hidden');
    elements.hud.classList.remove('tutorial-mode');
    elements.tutorialGuide.classList.add('hidden');
    elements.pause.classList.add('hidden');
    elements.results.classList.add('hidden');
    elements.postMatch.classList.add('hidden');
    elements.exitConfirmation.classList.add('hidden');
    state.exitConfirmOpen=false;
    confirmedExitAction=null;
    exitConfirmReturnFocus=null;
    elements.localScreen.classList.add('hidden');
    state.localOpen = false;
    elements.garageScreen.classList.add('hidden');
    state.garageOpen = false;
    elements.onlineScreen.classList.add('hidden');
    state.onlineOpen = false;
    elements.accountScreen.classList.add('hidden');
    state.accountOpen = false;
    elements.settingsScreen.classList.add('hidden');
    state.settingsOpen = false;
    elements.menu.classList.remove('hidden');
  },
  onHud: (vehicle,match) => updateHud(vehicle,match),
  onAim:(aim)=>updateAimHud(aim),
  onPostMatch: (match) => {
    elements.hud.classList.add('hidden');
    elements.pause.classList.add('hidden');
    elements.results.classList.add('hidden');
    const tied=match.type==='battle'&&!match.winnerTeam;
    const playerWon=match.type==='battle'
      ?Boolean(match.playerWon)
      :Boolean(match.winner?.isPlayer);
    elements.postMatchTitle.textContent=tied?'¡EMPATE!':playerWon?'¡VICTORIA!':'¡DERROTA!';
    elements.postMatch.classList.remove('hidden');
  },
  onStunt: (airTime) => showStunt(airTime),
  onChaseTag: (event) => showChaseTag(event),
  onBattleEvent: (event) => showBattleEvent(event),
  onRuptureEvent: (event) => showRuptureEvent(event),
  onCameraDistance: (preset) => showCameraDistance(preset),
  onMatchEnd: (match) => showResults(match),
  onOnlineLeave: () => leaveOnlineGame(),
});
game.cameraShakeStrength=settings.gameplay.cameraShake/100;
game.setAimSettings(settings.gameplay);
if(import.meta.env.DEV)window.__turboCrownInputTelemetry=()=>game.inputTelemetry.snapshot();
game.setGaragePreviewElement(elements.garagePreview);
game.setBotDifficulty(state.botDifficulty);

let suppressAccountPersistence=false;
let previousAccountStatus='guest';
const playerAccount=new PlayerAccount({
  onStateChange:(accountState)=>{
    renderAccountState(accountState);
    if(previousAccountStatus==='signed-in'&&accountState.status==='guest'){
      restoreGuestGarage();
    }
    previousAccountStatus=accountState.status;
  },
  onGarageChange:(cloudState)=>applyAccountGarage(cloudState),
});

const online=new OnlineClient({
  onStatus:(connection)=>handleOnlineConnection(connection),
  onNetwork:(network)=>{
    renderOnlineNetwork(network);
    game.setOnlineNetworkStats(network);
  },
  onRoom:(room,playerId)=>renderOnlineRoom(room,playerId),
  onError:(error)=>showOnlineError(error.message||'Ocurrió un error en la sala.'),
  onSessionLost:(event)=>handleOnlineSessionLost(event),
  onMatchStart:(match,playerId)=>renderOnlineMatchStart(match,playerId),
  onSnapshot:(snapshot)=>game.applyOnlineSnapshot(snapshot),
});
const automaticMatchmaking=new EdgegapMatchmakingClient();

let onlineStartTimer=null;
let scheduledOnlineMatchId=null;
let matchmakingDeadlineLocal=0;
let quickMatchPending=false;

// Herramienta de inspección local: permite revisar geometría y materiales sin
// exponer estado interno en el build final de Electron.
if (import.meta.env.DEV) {
  window.__toyboxGame = game;
}

function renderAccountState(accountState=playerAccount.snapshot()){
  const signedIn=accountState.status==='signed-in';
  const loading=accountState.status==='loading';
  const syncStatus=accountState.syncStatus||'local';
  const displayName=accountState.profile?.display_name
    ||accountState.user?.user_metadata?.display_name
    ||accountState.user?.email?.split('@')[0]
    ||'INVITADO';
  elements.accountButton.dataset.status=syncStatus;
  elements.accountButtonName.textContent=displayName.toUpperCase();
  elements.localPlayerName.textContent=displayName.toUpperCase();
  elements.accountButtonStatus.textContent=signedIn
    ?syncStatus==='synced'?'SINCRONIZADO':syncStatus==='syncing'?'SINCRONIZANDO':'REVISAR CONEXIÓN'
    :'GARAGE LOCAL';
  elements.accountCloudState.dataset.status=syncStatus;
  elements.accountCloudState.querySelector('span').textContent=signedIn
    ?syncStatus==='synced'?'GARAGE SINCRONIZADO':syncStatus==='syncing'?'SINCRONIZANDO':'ERROR DE SINCRONIZACIÓN'
    :'GARAGE LOCAL';
  elements.accountGuestPanel.classList.toggle('hidden',signedIn);
  elements.accountUserPanel.classList.toggle('hidden',!signedIn);
  elements.accountMessage.textContent=accountState.message||'Jugando como invitado.';
  elements.accountUserEmail.textContent=accountState.user?.email||'—';
  elements.accountUserName.textContent=displayName.toUpperCase();
  if(signedIn&&document.activeElement!==elements.accountDisplayName){
    elements.accountDisplayName.value=accountState.profile?.display_name||displayName;
  }
  elements.accountSignIn.disabled=loading||!accountState.configured;
  elements.accountSignUp.disabled=loading||!accountState.configured;
  elements.accountSaveProfile.disabled=loading;
  elements.accountSyncNow.disabled=loading;
  elements.accountSignOut.disabled=loading;
  updateGarageCount();
}

function setAccountAuthMode(mode,{focus=true}={}){
  accountAuthMode=mode==='register'?'register':'login';
  const registering=accountAuthMode==='register';
  elements.accountLoginTab.classList.toggle('selected',!registering);
  elements.accountRegisterTab.classList.toggle('selected',registering);
  elements.accountLoginTab.setAttribute('aria-selected',String(!registering));
  elements.accountRegisterTab.setAttribute('aria-selected',String(registering));
  elements.accountLoginForm.classList.toggle('hidden',registering);
  elements.accountRegisterForm.classList.toggle('hidden',!registering);
  if(registering&&!elements.accountRegisterEmail.value){
    elements.accountRegisterEmail.value=elements.accountLoginEmail.value;
  }else if(!registering&&!elements.accountLoginEmail.value){
    elements.accountLoginEmail.value=elements.accountRegisterEmail.value;
  }
  if(focus)requestAnimationFrame(()=>focusInterfaceElement(
    registering?elements.accountRegisterName:elements.accountLoginEmail,
  ));
}

function applyAccountGarage({garage:cloudGarage,selectedCarId,profile}){
  suppressAccountPersistence=true;
  state.garage=cloudGarage;
  const nextCarId=cloudGarage.ownedCars.includes(selectedCarId)
    ?selectedCarId
    :cloudGarage.ownedCars[0];
  buildCarOptions(elements.garageSearch.value);
  updateGarageCount();
  selectCar(nextCarId);
  suppressAccountPersistence=false;
  if(profile?.display_name&&!localStorage.getItem('toybox-online-name')){
    elements.onlinePlayerName.value=profile.display_name.slice(0,18);
  }
}

function restoreGuestGarage(){
  suppressAccountPersistence=true;
  state.garage=guestGarage;
  const nextCarId=guestGarage.ownedCars.includes(guestSelectedCarId)
    ?guestSelectedCarId
    :guestGarage.ownedCars[0];
  buildCarOptions(elements.garageSearch.value);
  updateGarageCount();
  selectCar(nextCarId);
  suppressAccountPersistence=false;
}

function openAccount(){
  state.accountOpen=true;
  state.localOpen=false;
  state.garageOpen=false;
  state.onlineOpen=false;
  input.clear();
  game.mode='menu';
  elements.menu.classList.add('hidden');
  elements.localScreen.classList.add('hidden');
  elements.garageScreen.classList.add('hidden');
  elements.onlineScreen.classList.add('hidden');
  elements.accountScreen.classList.remove('hidden');
  renderAccountState();
  setAccountAuthMode(accountAuthMode,{focus:false});
  requestAnimationFrame(()=>focusInterfaceElement(
    playerAccount.snapshot().status==='signed-in'
      ?elements.accountDisplayName
      :accountAuthMode==='register'
        ?elements.accountRegisterName
        :elements.accountLoginEmail,
  ));
}

function closeAccount(){
  state.accountOpen=false;
  input.clear();
  game.mode='menu';
  elements.accountScreen.classList.add('hidden');
  elements.menu.classList.remove('hidden');
  requestAnimationFrame(()=>focusInterfaceElement(elements.accountButton));
}

const SETTINGS_ACTION_NAMES=Object.freeze({
  forward:'acelerar',
  backward:'frenar / reversa',
  left:'doblar a la izquierda',
  right:'doblar a la derecha',
  jump:'saltar',
  handbrake:'usar el freno de mano',
  boost:'activar el nitro',
  stabilize:'estabilizar el auto',
  powerup:'usar el power-up',
  cameraDistance:'cambiar la distancia de cámara',
});

function renderSettings(){
  const effectiveGraphics=getEffectiveGraphicsSettings(settings.graphics);
  const graphicsLabels={low:'BAJO',medium:'MEDIO',high:'ALTO',custom:'PERSONALIZADO'};
  const customGraphics=settings.graphics.preset==='custom';
  elements.settingsLanguage.value=settings.language;
  elements.settingsMasterVolume.value=String(settings.audio.master);
  elements.settingsMusicVolume.value=String(settings.audio.music);
  elements.settingsEffectsVolume.value=String(settings.audio.effects);
  elements.settingsMasterValue.textContent=`${settings.audio.master}%`;
  elements.settingsMusicValue.textContent=`${settings.audio.music}%`;
  elements.settingsEffectsValue.textContent=`${settings.audio.effects}%`;
  elements.settingsGraphicsPreset.value=settings.graphics.preset;
  elements.settingsGraphicsSummary.textContent=settings.graphics.preset==='auto'
    ?`AUTO · ${graphicsLabels[effectiveGraphics.resolvedPreset]}`
    :graphicsLabels[effectiveGraphics.resolvedPreset];
  elements.settingsRenderScale.value=String(effectiveGraphics.renderScale);
  elements.settingsRenderScaleValue.textContent=`${effectiveGraphics.renderScale}%`;
  elements.settingsShadowQuality.value=effectiveGraphics.shadowQuality;
  elements.settingsParticleQuality.value=effectiveGraphics.particleQuality;
  elements.settingsFpsLimit.value=String(effectiveGraphics.fpsLimit);
  elements.settingsShowFps.checked=Boolean(settings.graphics.showFps);
  [
    elements.settingsRenderScale,
    elements.settingsShadowQuality,
    elements.settingsParticleQuality,
    elements.settingsFpsLimit,
  ].forEach((control)=>{control.disabled=!customGraphics;});
  elements.settingsCameraShake.value=String(settings.gameplay.cameraShake);
  elements.settingsCameraShakeValue.textContent=`${settings.gameplay.cameraShake}%`;
  elements.settingsControllerVibration.checked=Boolean(settings.gameplay.controllerVibration);
  elements.settingsControllerVibrationStrength.value=String(settings.gameplay.controllerVibrationStrength);
  elements.settingsControllerVibrationStrengthValue.textContent=`${settings.gameplay.controllerVibrationStrength}%`;
  elements.settingsControllerVibrationStrength.disabled=!settings.gameplay.controllerVibration;
  elements.settingsMouseSensitivity.value=String(settings.gameplay.mouseSensitivity);
  elements.settingsMouseSensitivityValue.textContent=`${settings.gameplay.mouseSensitivity}%`;
  elements.settingsInvertMouseY.checked=Boolean(settings.gameplay.invertMouseY);
  elements.settingsControllerAimSensitivity.value=String(settings.gameplay.controllerAimSensitivity);
  elements.settingsControllerAimSensitivityValue.textContent=`${settings.gameplay.controllerAimSensitivity}%`;
  elements.settingsMouseFire.value=String(settings.mouse.fireButton);
  elements.settingsMouseCameraControl.value=String(settings.mouse.cameraControlButton);
  elements.settingsMouseCameraReverse.value=String(settings.mouse.cameraReverseButton);
  elements.controlsDriveKey.textContent=[
    settings.controls.forward,
    settings.controls.left,
    settings.controls.backward,
    settings.controls.right,
  ].map(keyCodeLabel).join(' / ');
  elements.controlsJumpKey.textContent=`${keyCodeLabel(settings.controls.jump)} ×2`;
  elements.controlsBoostKey.textContent=`${keyCodeLabel(settings.controls.boost)} / B`;
  elements.settingsAirNitroKey.textContent=keyCodeLabel(settings.controls.boost);
  elements.controlsHandbrakeKey.textContent=keyCodeLabel(settings.controls.handbrake);
  elements.controlsFireKey.textContent='LMB / LB-RB';
  elements.controlsStabilizeKey.textContent=`${keyCodeLabel(settings.controls.stabilize)} / L3`;
  elements.controlsPowerupKey.textContent=`${keyCodeLabel(settings.controls.powerup)} / ↑`;
  elements.controlsCameraDistanceKey.textContent=`${keyCodeLabel(settings.controls.cameraDistance)} / Y`;
  elements.settingsKeyBindings.querySelectorAll('[data-binding-action]').forEach((button)=>{
    const action=button.dataset.bindingAction;
    button.textContent=keyCodeLabel(settings.controls[action]);
    button.classList.toggle('capturing',action===capturingBindingAction);
    button.setAttribute('aria-pressed',String(action===capturingBindingAction));
  });
  elements.settingsBindingMessage.textContent=capturingBindingAction
    ?`Presioná una tecla para ${SETTINGS_ACTION_NAMES[capturingBindingAction]}. Escape cancela.`
    :'Seleccioná una acción para reasignarla.';
}

function applySettings({persist=true}={}){
  if(persist)settings=saveGameSettings(settings,localStorage);
  if(i18n.language!==settings.language)i18n.setLanguage(settings.language);
  input.setBindings(settings.controls);
  input.setAimSettings({...settings.gameplay,mouse:settings.mouse});
  audio.setVolumes({
    master:settings.audio.master/100,
    music:settings.audio.music/100,
    effects:settings.audio.effects/100,
  });
  game.cameraShakeStrength=settings.gameplay.cameraShake/100;
  game.setAimSettings(settings.gameplay);
  const effectiveGraphics=getEffectiveGraphicsSettings(settings.graphics);
  game.setGraphicsSettings(effectiveGraphics);
  elements.graphicsFpsCounter.classList.toggle('hidden',!settings.graphics.showFps);
  input.setHaptics({
    enabled:settings.gameplay.controllerVibration,
    strength:settings.gameplay.controllerVibrationStrength/100,
  });
  renderSettings();
}

async function refreshFullscreenSetting(){
  try{
    elements.settingsFullscreen.checked=window.toyboxDesktop?.getFullscreen
      ?Boolean(await window.toyboxDesktop.getFullscreen())
      :Boolean(document.fullscreenElement);
  }catch{
    elements.settingsFullscreen.checked=Boolean(document.fullscreenElement);
  }
}

function openSettings(returnContext='menu'){
  settingsReturnContext=returnContext==='pause'?'pause':'menu';
  capturingBindingAction=null;
  input.enabled=true;
  input.clear();
  state.settingsOpen=true;
  state.localOpen=false;
  state.garageOpen=false;
  state.onlineOpen=false;
  state.accountOpen=false;
  elements.menu.classList.add('hidden');
  elements.localScreen.classList.add('hidden');
  elements.garageScreen.classList.add('hidden');
  elements.onlineScreen.classList.add('hidden');
  elements.accountScreen.classList.add('hidden');
  elements.pause.classList.add('hidden');
  elements.settingsScreen.classList.remove('hidden');
  renderSettings();
  refreshFullscreenSetting();
  requestAnimationFrame(()=>focusInterfaceElement(elements.settingsDone));
}

function closeSettings(){
  if(!state.settingsOpen)return;
  state.settingsOpen=false;
  capturingBindingAction=null;
  input.enabled=true;
  input.clear();
  elements.settingsScreen.classList.add('hidden');
  if(settingsReturnContext==='pause'&&(game.mode==='paused'||game.onlinePaused)){
    elements.pause.classList.remove('hidden');
    requestAnimationFrame(()=>focusInterfaceElement(elements.resumeButton));
    return;
  }
  game.mode='menu';
  elements.menu.classList.remove('hidden');
  requestAnimationFrame(()=>focusInterfaceElement(elements.settingsButton));
}

async function runAccountAction(action){
  elements.accountMessage.textContent='Procesando…';
  try{
    await action();
  }catch(error){
    elements.accountMessage.textContent=error?.message||'No se pudo completar la operación.';
  }
}

const LOCAL_MODE_NAMES={
  rupture:'RUPTURA TURBO',
  chase:'PERSECUCIÓN',
  battle:'BATALLA 5 VS 5',
  ffa:'TODOS CONTRA TODOS',
};

function updateLocalSelectionSummary(){
  const map=state.localMode==='rupture'
    ?getRuptureMap(state.ruptureMapId)
    :getMap(state.mapId);
  const difficulty=getBotDifficulty(state.botDifficulty);
  elements.localSelectionSummary.textContent=`${LOCAL_MODE_NAMES[state.localMode]} · ${map.name.toUpperCase()} · IA ${difficulty.shortName}`;
}

function selectedLocalMapId(){
  return state.localMode==='rupture'?state.ruptureMapId:state.mapId;
}

function selectLocalMap(id){
  if(state.localMode==='rupture'){
    const map=RUPTURE_MAPS.find((item)=>item.id===id)||RUPTURE_MAPS[0];
    state.ruptureMapId=map.id;
    localStorage.setItem('toybox-rupture-map',map.id);
    elements.mapList.querySelectorAll('[data-map]').forEach((button)=>{
      const selected=button.dataset.map===map.id;
      button.classList.toggle('selected',selected);
      button.setAttribute('aria-selected',String(selected));
    });
    updateLocalSelectionSummary();
    return;
  }
  selectMap(id);
}

function selectLocalMode(mode){
  if(!LOCAL_MODE_NAMES[mode])return;
  state.localMode=mode;
  localStorage.setItem('toybox-local-mode',mode);
  elements.localModeList.querySelectorAll('[data-local-mode]').forEach((button)=>{
    const selected=button.dataset.localMode===mode;
    button.classList.toggle('selected',selected);
    button.setAttribute('aria-selected',String(selected));
  });
  elements.localMapTitle.textContent=mode==='rupture'
    ?'Elegí la isla suspendida'
    :'Elegí el campo de juego';
  buildMapOptions();
  selectLocalMap(selectedLocalMapId());
}

function selectBotDifficulty(id){
  const difficulty=getBotDifficulty(id);
  state.botDifficulty=difficulty.id;
  localStorage.setItem('toybox-bot-difficulty',difficulty.id);
  game.setBotDifficulty(difficulty.id);
  elements.localBotDifficulty.querySelectorAll('[data-bot-difficulty]').forEach((button)=>{
    const selected=button.dataset.botDifficulty===difficulty.id;
    button.classList.toggle('selected',selected);
    button.setAttribute('aria-selected',String(selected));
  });
  elements.onlineBotDifficulty.value=difficulty.id;
  updateLocalSelectionSummary();
}

function openLocal(){
  state.localOpen=true;
  state.garageOpen=false;
  state.onlineOpen=false;
  state.accountOpen=false;
  input.clear();
  game.mode='menu';
  elements.menu.classList.add('hidden');
  elements.garageScreen.classList.add('hidden');
  elements.onlineScreen.classList.add('hidden');
  elements.accountScreen.classList.add('hidden');
  elements.localScreen.classList.remove('hidden');
  buildMapOptions();
  selectLocalMap(selectedLocalMapId());
  requestAnimationFrame(()=>focusInterfaceElement(
    elements.localModeList.querySelector('.selected')||elements.localStart,
  ));
}

function closeLocal(){
  state.localOpen=false;
  input.clear();
  game.mode='menu';
  elements.localScreen.classList.add('hidden');
  elements.menu.classList.remove('hidden');
  if(game.selectedMapId!==state.mapId)game.setMap(state.mapId);
  requestAnimationFrame(()=>focusInterfaceElement(elements.localButton));
}

function startSelectedLocalMatch(){
  if(state.localMode==='rupture'){
    game.setMap(state.ruptureMapId);
    game.startRupture();
    return;
  }
  if(game.selectedMapId!==state.mapId)game.setMap(state.mapId);
  if(state.localMode==='battle')game.startBattle();
  else if(state.localMode==='ffa')game.startFreeForAll();
  else game.startChase();
}

function getCosmeticDefinition(slot = state.cosmeticSlot) {
  return COSMETIC_SLOTS.find((definition) => definition.id === slot) || COSMETIC_SLOTS[0];
}

function getCosmeticItem(slot, itemId) {
  const definition = getCosmeticDefinition(slot);
  return definition.catalog.find((item) => item.id === itemId) || definition.catalog[0];
}

function buildCarOptions(query = '') {
  const normalizedQuery = query.trim().toLocaleLowerCase('es');
  const ownedCars=new Set(state.garage.ownedCars);
  const visibleCars = CARS.filter((car) => `${car.name} ${car.className}`.toLocaleLowerCase('es').includes(normalizedQuery));
  elements.carList.innerHTML = visibleCars.map((car) => `
    <button class="car-option${car.thumbnailUrl?' has-thumbnail':''}${ownedCars.has(car.id)?'':car.purchasable===false?' unavailable':' locked'}" type="button" role="option" data-car="${safeHtml(car.id)}" data-price="${Math.max(1,Number(car.priceCrowns)||250)}" data-owned="${String(ownedCars.has(car.id))}" aria-label="${safeHtml(car.className)}: ${safeHtml(car.name)}" style="--car-color:${safeHtml(car.color)}">
      ${car.thumbnailUrl
        ?`<span class="car-thumbnail">${thumbnailImage(car.thumbnailUrl,car.name)}</span>`
        :'<span class="car-silhouette"></span>'}
      <span class="car-option-label"><b>${safeHtml(car.name)}</b><small>${safeHtml(car.className)}</small></span>
    </button>
  `).join('') || '<p class="collection-empty">No hay autos que coincidan.</p>';
  updateSelectedCarButton();
}

function buildCosmeticTabs() {
  elements.cosmeticTabs.innerHTML = COSMETIC_SLOTS.map((definition) => `
    <button class="cosmetic-tab" type="button" data-slot="${definition.id}">
      <span>${definition.icon}</span>${definition.label.toUpperCase()}
    </button>
  `).join('');
  updateSelectedCosmeticTab();
}

function updateSelectedCarButton() {
  elements.carList.querySelectorAll('[data-car]').forEach((button) => {
    const selected = button.dataset.car === state.carId;
    button.classList.toggle('selected', selected);
    button.setAttribute('aria-selected', String(selected));
  });
}

function updateSelectedCosmeticTab() {
  elements.cosmeticTabs.querySelectorAll('[data-slot]').forEach((button) => {
    const selected = button.dataset.slot === state.cosmeticSlot;
    button.classList.toggle('selected', selected);
    button.setAttribute('aria-selected', String(selected));
  });
  const copy={
    wheelId:['AUTO COMPLETO','Carrocería, ruedas y cañón equipados'],
    engineSoundId:['SONIDO DE MOTOR','El auto reproduce el carácter sonoro equipado'],
    cannonId:['ARSENAL EQUIPADO','Vista del cañón equipado sobre el auto'],
    projectileId:['PRUEBA DE PROYECTIL','El cañón dispara continuamente el proyectil seleccionado'],
    nitroId:['PRUEBA DE NITRO','El efecto equipado funciona continuamente'],
    explosionId:['PRUEBA DE EXPLOSIÓN','La animación equipada se repite automáticamente'],
    tombstoneId:['VISTA DE LÁPIDA','Solo se muestra el marcador de eliminación equipado'],
  }[state.cosmeticSlot];
  elements.garagePreviewTitle.textContent=copy[0];
  elements.garagePreviewDescription.textContent=copy[1];
  elements.garagePreview.dataset.slot=state.cosmeticSlot;
}

function renderCosmeticOptions() {
  const focusedItemId=gamepadNavigationActive?document.activeElement?.dataset.cosmetic:null;
  const definition = getCosmeticDefinition();
  const loadout = getCarLoadout(state.garage, state.carId);
  const equippedId = loadout[state.cosmeticSlot];
  const ownedItems = new Set(getOwnedCatalog(state.garage, state.cosmeticSlot).map((item)=>item.id));
  elements.cosmeticList.innerHTML = definition.catalog.map((item) => `
    <button class="cosmetic-card${item.id === equippedId ? ' selected' : ''}${ownedItems.has(item.id)?'':item.purchasable===false?' unavailable':' locked'}" type="button" role="option" data-cosmetic="${safeHtml(item.id)}" data-price="${Math.max(1,Number(item.priceCrowns)||250)}" data-owned="${String(ownedItems.has(item.id))}" aria-selected="${String(item.id === equippedId)}" style="--item-color:${safeHtml(item.color)};--item-accent:${safeHtml(item.accent)}">
      <span class="cosmetic-preview${item.thumbnailUrl?' has-thumbnail':''}">${item.thumbnailUrl
        ?thumbnailImage(item.thumbnailUrl,item.name)
        :definition.icon}</span>
      <span><b>${safeHtml(item.name)}</b><small>${safeHtml(item.description)}</small></span>
    </button>
  `).join('');
  updateCosmeticDetail(equippedId);
  if(focusedItemId)requestAnimationFrame(()=>{
    const replacement=elements.cosmeticList.querySelector(`[data-cosmetic="${CSS.escape(focusedItemId)}"]`)
      ||elements.cosmeticList.querySelector('.selected');
    focusInterfaceElement(replacement);
  });
}

function updateCosmeticDetail(itemId) {
  const definition = getCosmeticDefinition();
  const item = getCosmeticItem(state.cosmeticSlot, itemId);
  elements.cosmeticDetailIcon.innerHTML=item.thumbnailUrl
    ?thumbnailImage(item.thumbnailUrl,item.name)
    :safeHtml(definition.icon);
  elements.cosmeticDetailIcon.classList.toggle('has-thumbnail',Boolean(item.thumbnailUrl));
  elements.cosmeticDetailIcon.style.background = item.thumbnailUrl?'#151426':item.accent;
  elements.cosmeticDetailName.textContent = item.name.toUpperCase();
  elements.cosmeticDetailDescription.textContent = item.description;
  const owned=getOwnedCatalog(state.garage,state.cosmeticSlot).some((candidate)=>candidate.id===item.id);
  elements.cosmeticDetailStatus.textContent=owned
    ?'EN COLECCIÓN'
    :item.purchasable===false?'NO DISPONIBLE':`${Math.max(1,Number(item.priceCrowns)||250)} CORONAS`;
}

function buildMapOptions() {
  const maps=state.localMode==='rupture'?RUPTURE_MAPS:MAPS;
  elements.mapList.innerHTML = maps.map((map) => `
    <button class="map-option" type="button" role="option" data-map="${map.id}" aria-label="${map.name}" style="--map-color:${map.color}">
      <span class="map-thumb"></span>
      <span class="map-copy"><strong>${map.name}</strong><small>${map.description}</small></span>
      <span class="map-check">✓</span>
    </button>
  `).join('');
}

function selectCar(id) {
  if (!state.garage.ownedCars.includes(id)) return;
  const car=getCar(id);state.carId=id;localStorage.setItem('toybox-car',id);
  state.cosmeticSlot='wheelId';
  if(!suppressAccountPersistence){
    if(playerAccount.snapshot().status==='signed-in')playerAccount.setSelectedCar(id);
    else guestSelectedCarId=id;
  }
  updateSelectedCarButton();
  updateSelectedCosmeticTab();
  elements.garageCarClass.textContent=car.className.toUpperCase();elements.garageCarName.textContent=car.name.toUpperCase();elements.garageCarDescription.textContent=car.description;
  const loadout=getCarLoadout(state.garage,id);
  renderCosmeticOptions();
  game.setCar(id,loadout);
  if(state.garageOpen)game.updateGaragePreview(id,loadout,state.cosmeticSlot);
}

function selectCosmetic(itemId) {
  if(!equipCosmetic(state.garage,state.carId,state.cosmeticSlot,itemId))return;
  const signedIn=playerAccount.snapshot().status==='signed-in';
  if(signedIn){
    playerAccount.saveLoadout(state.carId,getCarLoadout(state.garage,state.carId));
  }else{
    state.garage=saveGarage(state.garage,localStorage);
    guestGarage=state.garage;
  }
  const loadout=getCarLoadout(state.garage,state.carId);
  renderCosmeticOptions();
  game.setLoadout(loadout);
  if(state.garageOpen)game.updateGaragePreview(state.carId,loadout,state.cosmeticSlot);
  elements.garageLoadoutStatus.textContent='EQUIPADO';
}

function updateGarageCount() {
  const cosmeticCount=COSMETIC_SLOTS.reduce((sum,definition)=>sum+getOwnedCatalog(state.garage,definition.id).length,0);
  elements.garageOwnedCount.textContent=`${String(state.garage.ownedCars.length).padStart(2,'0')} AUTOS · ${String(cosmeticCount).padStart(2,'0')} COSMÉTICOS`;
  const account=playerAccount.snapshot();
  elements.garageWallet.textContent=account.status==='signed-in'
    ?`♛ ${Number(account.wallet?.balance||0).toLocaleString('es-AR')} CORONAS`
    :'♛ INICIÁ SESIÓN';
}

function closePurchaseConfirmation({restoreFocus=true}={}) {
  const returnElement=pendingPurchase?.returnElement;
  pendingPurchase=null;
  state.purchaseOpen=false;
  elements.purchaseConfirmation.classList.add('hidden');
  elements.purchaseConfirmAccept.disabled=false;
  elements.purchaseConfirmCancel.disabled=false;
  elements.purchaseConfirmCancel.classList.remove('hidden');
  elements.purchaseConfirmMessage.textContent='';
  elements.purchaseConfirmation.querySelector('.purchase-confirm-card')?.removeAttribute('data-state');
  if(restoreFocus&&returnElement?.isConnected){
    requestAnimationFrame(()=>focusInterfaceElement(returnElement));
  }
}

function openPurchaseConfirmation(item,{kind='cosmetic',slot=state.cosmeticSlot,returnElement=null}={}) {
  const account=playerAccount.snapshot();
  const price=Math.max(1,Number(item.priceCrowns)||250);
  pendingPurchase={item,kind,slot,returnElement};
  state.purchaseOpen=true;
  elements.purchaseConfirmTitle.textContent=`Desbloquear ${item.name}`;
  elements.purchaseConfirmCopy.textContent='Este artículo quedará asociado permanentemente a tu cuenta.';
  elements.purchaseConfirmIcon.innerHTML=item.thumbnailUrl
    ?thumbnailImage(item.thumbnailUrl,item.name)
    :kind==='vehicle'?'▱':safeHtml(getCosmeticDefinition(slot).icon);
  elements.purchaseConfirmIcon.classList.toggle('has-thumbnail',Boolean(item.thumbnailUrl));
  elements.purchaseConfirmPrice.textContent=`♛ ${price.toLocaleString('es-AR')} CORONAS`;
  elements.purchaseConfirmMessage.textContent='';
  elements.purchaseConfirmAccept.disabled=false;
  elements.purchaseConfirmAccept.textContent='CANJEAR';
  elements.purchaseConfirmCancel.classList.remove('hidden');
  if(account.status!=='signed-in'){
    elements.purchaseConfirmCopy.textContent='Iniciá sesión para guardar tu colección y canjear artículos.';
    elements.purchaseConfirmPrice.textContent='CUENTA REQUERIDA';
    elements.purchaseConfirmAccept.textContent='INICIAR SESIÓN';
  }else if(!account.economyAvailable){
    elements.purchaseConfirmMessage.textContent='La economía todavía no está habilitada en este entorno.';
    elements.purchaseConfirmAccept.disabled=true;
  }else if(Number(account.wallet?.balance||0)<price){
    elements.purchaseConfirmMessage.textContent=`Te faltan ${(price-Number(account.wallet?.balance||0)).toLocaleString('es-AR')} Coronas.`;
    elements.purchaseConfirmAccept.disabled=true;
  }
  elements.purchaseConfirmation.classList.remove('hidden');
  requestAnimationFrame(()=>focusInterfaceElement(
    elements.purchaseConfirmAccept.disabled?elements.purchaseConfirmCancel:elements.purchaseConfirmAccept,
  ));
}

async function confirmPendingPurchase() {
  if(!pendingPurchase)return;
  const account=playerAccount.snapshot();
  if(account.status!=='signed-in'){
    closePurchaseConfirmation({restoreFocus:false});
    openAccount();
    return;
  }
  if(pendingPurchase.complete){
    closePurchaseConfirmation();
    return;
  }
  const purchase={...pendingPurchase};
  elements.purchaseConfirmAccept.disabled=true;
  elements.purchaseConfirmCancel.disabled=true;
  elements.purchaseConfirmMessage.textContent='Procesando el canje…';
  try{
    await playerAccount.purchaseItem(purchase.item.id);
    if(purchase.kind==='vehicle')selectCar(purchase.item.id);
    else{
      state.cosmeticSlot=purchase.slot;
      selectCosmetic(purchase.item.id);
    }
    elements.purchaseConfirmation.querySelector('.purchase-confirm-card')?.setAttribute('data-state','success');
    elements.purchaseConfirmMessage.textContent='¡Artículo desbloqueado y equipado!';
    elements.purchaseConfirmAccept.textContent='LISTO';
    elements.purchaseConfirmAccept.disabled=false;
    elements.purchaseConfirmCancel.classList.add('hidden');
    pendingPurchase={...purchase,complete:true};
    focusInterfaceElement(elements.purchaseConfirmAccept);
  }catch(error){
    elements.purchaseConfirmMessage.textContent=error.message||'No se pudo completar el canje.';
    elements.purchaseConfirmAccept.disabled=false;
    elements.purchaseConfirmCancel.disabled=false;
  }
}

function openGarage() {
  state.garageOpen=true;
  state.localOpen=false;
  state.onlineOpen=false;
  state.accountOpen=false;
  elements.menu.classList.add('hidden');
  elements.localScreen.classList.add('hidden');
  elements.onlineScreen.classList.add('hidden');
  elements.accountScreen.classList.add('hidden');
  elements.garageScreen.classList.remove('hidden');
  updateGarageCount();
  buildCarOptions(elements.garageSearch.value);
  renderCosmeticOptions();
  game.openGaragePreview(state.carId,getCarLoadout(state.garage,state.carId),state.cosmeticSlot);
  if(playerAccount.snapshot().status==='signed-in')playerAccount.refresh().catch(()=>{});
  requestAnimationFrame(()=>{
    const selectedCar=elements.carList.querySelector('.selected');
    focusInterfaceElement(selectedCar||elements.garageClose);
  });
}

function closeGarage() {
  state.garageOpen=false;
  elements.garageScreen.classList.add('hidden');
  elements.menu.classList.remove('hidden');
  game.closeGaragePreview();
  requestAnimationFrame(()=>focusInterfaceElement(elements.garageOpen));
}

const ONLINE_MODE_NAMES={
  battle:'BATALLA 5 VS 5',
  ffa:'TODOS CONTRA TODOS',
  chase:'PERSECUCIÓN',
  rupture:'RUPTURA TURBO',
};

function syncOnlineMapSelection(){
  const rupture=elements.onlineMode.value==='rupture';
  const ruptureIds=new Set(RUPTURE_MAPS.map((map)=>map.id));
  elements.onlineMap.querySelectorAll('option').forEach((option)=>{
    const ruptureOption=ruptureIds.has(option.value);
    option.hidden=rupture?!ruptureOption:ruptureOption;
  });
  if(rupture&&!ruptureIds.has(elements.onlineMap.value)){
    elements.onlineMap.value=getRuptureMap(state.ruptureMapId).id;
  }else if(!rupture&&ruptureIds.has(elements.onlineMap.value)){
    elements.onlineMap.value=state.mapId;
  }
}

function showOnlineError(message=''){
  elements.onlineError.textContent=message;
  elements.onlineError.classList.toggle('hidden',!message);
}

function renderOnlineConnection({status,detail='',url=online.serverUrl}){
  const labels={offline:'DESCONECTADO',ready:'EDGEGAP LISTO',connecting:'CONECTANDO',reconnecting:'RECONECTANDO',online:'CONECTADO',error:'ERROR DE CONEXIÓN'};
  elements.onlineConnection.dataset.status=status;
  elements.onlineConnection.querySelector('span').textContent=labels[status]||status.toUpperCase();
  if(status!=='online')elements.onlineConnectionDetail.textContent=status==='reconnecting'?'RECUPERANDO SESIÓN':'—';
  elements.onlineStatusCopy.textContent=detail||(status==='online'
    ?`Servidor disponible en ${url}`:(status==='connecting'||status==='reconnecting')?'Iniciando conexión con el servidor…':'El servidor local no está conectado.');
}

function renderOnlineNetwork(network={rtt:null,jitter:0,loss:0,quality:'offline'}){
  const qualityLabels={excellent:'EXCELENTE',good:'BUENA',fair:'INESTABLE',poor:'DEFICIENTE',checking:'MIDIENDO',offline:'SIN RED'};
  const ping=network.rtt===null?'—':`${network.rtt} MS`;
  const loss=`${network.loss||0}% PÉRDIDA`;
  elements.onlineConnection.dataset.quality=network.quality;
  elements.onlineConnectionDetail.textContent=network.rtt===null
    ?qualityLabels[network.quality]||'—'
    :`${ping} · ${loss}`;
  elements.onlineNetwork.dataset.quality=network.quality;
  elements.onlineNetworkPing.textContent=network.rtt===null?qualityLabels[network.quality]||'MIDIENDO':ping;
  elements.onlineNetworkLoss.textContent=network.rtt===null?'—':`${loss} · J ${network.jitter||0} MS`;
}

function handleOnlineConnection(connection){
  renderOnlineConnection(connection);
  if(game.mode==='online-game'&&connection.status==='reconnecting'){
    clearTimeout(stuntTimer);
    elements.messageToast.textContent='RECONECTANDO CON LA PARTIDA…';
    elements.messageToast.classList.remove('hidden');
    return;
  }
  if(game.mode==='online-game'&&connection.status==='online'&&connection.detail){
    clearTimeout(stuntTimer);
    elements.messageToast.textContent='CONEXIÓN RECUPERADA';
    elements.messageToast.classList.remove('hidden');
    stuntTimer=setTimeout(()=>elements.messageToast.classList.add('hidden'),1600);
    return;
  }
  if(game.mode!=='online-game'||(connection.status!=='offline'&&connection.status!=='error'))return;
  clearTimeout(onlineStartTimer);
  scheduledOnlineMatchId=null;
  game.backToMenu();
  clearTimeout(stuntTimer);
  elements.messageToast.textContent='SE PERDIÓ LA CONEXIÓN ONLINE';
  elements.messageToast.classList.remove('hidden');
  stuntTimer=setTimeout(()=>elements.messageToast.classList.add('hidden'),2200);
}

function handleOnlineSessionLost({message}){
  clearTimeout(onlineStartTimer);
  scheduledOnlineMatchId=null;
  if(game.mode==='online-game'||game.mode==='results')game.backToMenu();
  clearTimeout(stuntTimer);
  elements.messageToast.textContent='LA RESERVA DE LA SESIÓN VENCIÓ';
  elements.messageToast.classList.remove('hidden');
  stuntTimer=setTimeout(()=>elements.messageToast.classList.add('hidden'),2400);
  showOnlineError(message);
}

function renderOnlineRoom(room,playerId=online.playerId){
  const inRoom=Boolean(room);
  if(inRoom)quickMatchPending=false;
  elements.onlineQuickMatch.disabled=inRoom||quickMatchPending;
  elements.onlineEntry.classList.toggle('hidden',inRoom);
  elements.onlineLobby.classList.toggle('hidden',!inRoom);
  elements.onlineMode.disabled=inRoom;
  syncOnlineMapSelection();
  elements.onlineMap.disabled=inRoom;
  elements.onlineBotDifficulty.disabled=inRoom;
  elements.onlineMatchNotice.classList.add('hidden');
  if(!room)return;
  const me=room.players.find((player)=>player.id===playerId);
  const isHost=room.hostId===playerId;
  const isPublic=room.visibility==='public';
  const allReady=room.players.length>=2&&room.players.every((player)=>player.ready&&player.connected!==false);
  const lobbyOpen=room.status==='lobby';
  elements.onlineMode.value=room.mode;
  elements.onlineMap.value=room.mapId;
  elements.onlineBotDifficulty.value=getBotDifficulty(room.botDifficulty).id;
  syncOnlineMapSelection();
  elements.onlineMode.disabled=!isHost||!lobbyOpen||isPublic;
  elements.onlineMap.disabled=!isHost||!lobbyOpen||isPublic;
  elements.onlineBotDifficulty.disabled=!isHost||!lobbyOpen||isPublic;
  elements.onlineRoomCode.textContent=room.code;
  elements.onlineRoomCapacity.textContent=`${room.players.length} / ${room.maxPlayers}`;
  elements.onlinePlayerList.innerHTML=room.players.map((player,index)=>{
    const car=getCar(player.carId);
    const tags=[player.isBot?'BOT':player.isHost?'ANFITRIÓN':'',player.id===playerId?'VOS':''].filter(Boolean).join(' · ');
    const disconnected=player.connected===false;
    return `<div class="online-player-row${player.ready?' ready':''}${disconnected?' disconnected':''}" style="--player-color:${car.color}">
      <span>${String(index+1).padStart(2,'0')}</span>
      <div><b>${player.name}</b><small>${car.name.toUpperCase()}${tags?` · ${tags}`:''}</small></div>
      <strong>${player.isBot?'BOT':disconnected?'RECONECTANDO':player.ready?'LISTO':'PREPARANDO'}</strong>
    </div>`;
  }).join('');
  elements.onlineReady.classList.toggle('hidden',isPublic);
  elements.onlineReady.disabled=!lobbyOpen||isPublic;
  elements.onlineReady.textContent=me?.ready?'CANCELAR LISTO':'ESTOY LISTO';
  elements.onlineReady.classList.toggle('selected',Boolean(me?.ready));
  elements.onlineStartMatch.classList.toggle('hidden',!isHost||isPublic);
  elements.onlineStartMatch.disabled=!lobbyOpen||!allReady;
  if(isPublic&&lobbyOpen){
    matchmakingDeadlineLocal=Date.now()+Math.max(0,(room.autoStartsAt||room.serverTime)-room.serverTime);
    elements.onlineMatchNotice.classList.remove('hidden');
    updateMatchmakingNotice();
  }
  if(room.status==='finished'){
    elements.onlineMatchCopy.textContent=isHost
      ?'PARTIDA FINALIZADA · PREPARÁ LA REVANCHA'
      :'PARTIDA FINALIZADA · ESPERANDO AL ANFITRIÓN';
    elements.onlineMatchNotice.classList.remove('hidden');
  }
  if((room.status==='starting'||room.status==='playing')&&online.match)renderOnlineMatchStart(online.match,playerId);
}

function updateMatchmakingNotice(){
  const room=online.room;
  if(room?.visibility!=='public'||room.status!=='lobby')return;
  const remaining=Math.max(0,Math.ceil((matchmakingDeadlineLocal-Date.now())/1000));
  elements.onlineMatchCopy.textContent=room.players.length>=room.maxPlayers
    ?'SALA COMPLETA · INICIANDO PARTIDA…'
    :`BUSCANDO RIVALES · LOS BOTS COMPLETAN EN ${remaining}s`;
}

setInterval(updateMatchmakingNotice,250);

function renderOnlineMatchStart(match,playerId=online.playerId){
  const assignment=match.players.find((player)=>player.id===playerId);
  const mapName=match.mode==='rupture'
    ?getRuptureMap(match.mapId).name
    :getMap(match.mapId).name;
  const teamCopy=assignment?.teamId?` · EQUIPO ${assignment.teamId.toUpperCase()}`:'';
  elements.onlineMatchCopy.textContent=`${ONLINE_MODE_NAMES[match.mode]} · ${mapName.toUpperCase()}${teamCopy} · SEMILLA ${match.seed}`;
  elements.onlineMatchNotice.classList.remove('hidden');
  elements.onlineReady.disabled=true;
  elements.onlineStartMatch.disabled=true;
  if(match.botDifficulty)selectBotDifficulty(match.botDifficulty);
  if(scheduledOnlineMatchId===match.id)return;
  clearTimeout(onlineStartTimer);
  scheduledOnlineMatchId=match.id;
  if(match.mode==='rupture'){
    state.ruptureMapId=match.mapId;
    localStorage.setItem('toybox-rupture-map',match.mapId);
  }else selectMap(match.mapId);
  // El armado del mapa puede consumir varios frames. Recalculamos después
  // para que ese trabajo tampoco prolongue la cuenta regresiva del jugador.
  const startsInMs=online.matchStartsInMs(match);
  game.startOnlineMatch(
    {...match,startsInMs},
    playerId,
    (seq,controls,metadata)=>online.sendMatchInput(match.id,seq,controls,metadata),
  );
}

async function ensureOnlineConnection(){
  showOnlineError();
  elements.onlineConnect.disabled=true;
  try{
    await online.connect(elements.onlineServerUrl.value);
    return true;
  }catch(error){
    showOnlineError(error.message);
    return false;
  }finally{
    elements.onlineConnect.disabled=false;
  }
}

async function connectAssignedServer(serverUrl){
  let lastError=null;
  for(let attempt=1;attempt<=20;attempt+=1){
    if(!state.onlineOpen)throw new DOMException('Operación cancelada.','AbortError');
    try{
      await online.connect(serverUrl);
      return true;
    }catch(error){
      lastError=error;
      elements.onlineStatusCopy.textContent=`SERVIDOR ASIGNADO · CONECTANDO (${attempt}/20)…`;
      await new Promise((resolve)=>setTimeout(resolve,1000));
    }
  }
  throw lastError||new Error('No se pudo conectar con el servidor regional.');
}

async function startQuickMatch(){
  if(quickMatchPending)return;
  quickMatchPending=true;
  elements.onlineQuickMatch.disabled=true;
  showOnlineError();
  const identity=onlineIdentity();
  try{
    const ticket=await automaticMatchmaking.findServer({
      serverUrl:elements.onlineServerUrl.value||online.serverUrl,
      mode:elements.onlineMode.value,
      mapId:elements.onlineMap.value,
      onStatus:({message})=>{elements.onlineStatusCopy.textContent=message;},
    });
    if(!state.onlineOpen)return;
    const city=ticket.location?.city?` · ${String(ticket.location.city).toUpperCase()}`:'';
    elements.onlineStatusCopy.textContent=`SERVIDOR REGIONAL LISTO${city} · CONECTANDO…`;
    await connectAssignedServer(ticket.serverUrl);
    if(!online.quickMatch({
      ...identity,
      mode:elements.onlineMode.value,
      mapId:elements.onlineMap.value,
      botDifficulty:elements.onlineBotDifficulty.value,
    })){
      throw new Error('El servidor regional no aceptó la búsqueda.');
    }
    // Edgegap administra el ciclo del ticket una vez asignado el host. El
    // director de desarrollo sí necesita que liberemos su reserva explícita.
    automaticMatchmaking.releaseAfterConnect();
  }catch(error){
    if(error.name==='AbortError')return;
    if(error.code==='MATCHMAKER_UNAVAILABLE'){
      elements.onlineStatusCopy.textContent='ASIGNACIÓN AUTOMÁTICA NO CONFIGURADA · USANDO SERVIDOR MANUAL';
      if(await ensureOnlineConnection()){
        online.quickMatch({
          ...identity,
          mode:elements.onlineMode.value,
          mapId:elements.onlineMap.value,
          botDifficulty:elements.onlineBotDifficulty.value,
        });
      }
      return;
    }
    showOnlineError(error.message||'No se pudo preparar la partida rápida.');
    renderOnlineConnection({status:online.status,detail:error.message,url:online.serverUrl});
  }finally{
    quickMatchPending=false;
    elements.onlineQuickMatch.disabled=Boolean(online.room);
  }
}

function onlineBotCatalog(){
  return createBotAppearanceDeck({
    cars:CARS,
    cosmeticSlots:COSMETIC_SLOTS,
    count:ONLINE_BOT_APPEARANCE_LIMIT,
    defaultLoadoutFor:(car)=>({
        wheelId:car.defaultWheelId,
        engineSoundId:car.defaultEngineSoundId,
        cannonId:car.defaultCannonId,
        projectileId:car.defaultProjectileId,
        nitroId:car.defaultNitroId,
        explosionId:car.defaultExplosionId,
        tombstoneId:car.defaultTombstoneId,
    }),
    colliderFor:(car)=>getImportedVehicleCollider(car.id)||networkColliderFor(car.id),
  });
}

function onlineIdentity(){
  const name=elements.onlinePlayerName.value.trim().slice(0,18)||'PILOTO';
  elements.onlinePlayerName.value=name;
  localStorage.setItem('toybox-online-name',name);
  return {
    name,
    carId:state.carId,
    loadout:getCarLoadout(state.garage,state.carId),
    collider:getImportedVehicleCollider(state.carId)||networkColliderFor(state.carId),
    botCatalog:onlineBotCatalog(),
    account:playerAccount.getOnlineAccount(),
  };
}

async function openOnline(){
  state.onlineOpen=true;
  state.localOpen=false;
  state.garageOpen=false;
  state.accountOpen=false;
  input.clear();
  game.mode='online';
  elements.menu.classList.add('hidden');
  elements.localScreen.classList.add('hidden');
  elements.garageScreen.classList.add('hidden');
  elements.accountScreen.classList.add('hidden');
  elements.onlineScreen.classList.remove('hidden');
  const accountName=playerAccount.snapshot().profile?.display_name;
  elements.onlinePlayerName.value=localStorage.getItem('toybox-online-name')
    ||accountName?.slice(0,18)
    ||`PILOTO ${String(Math.floor(Math.random()*900)+100)}`;
  elements.onlineServerUrl.value=online.serverUrl;
  elements.onlineMode.value='ffa';
  elements.onlineMap.value=state.mapId;
  elements.onlineBotDifficulty.value=state.botDifficulty;
  syncOnlineMapSelection();
  renderOnlineRoom(online.room,online.playerId);
  requestAnimationFrame(()=>focusInterfaceElement(elements.onlineQuickMatch));
  if(automaticMatchmaking.isManagedConfigured){
    if(online.hasRecovery()){
      try{
        elements.onlineStatusCopy.textContent='RECUPERANDO LA PARTIDA REGIONAL…';
        await connectAssignedServer(online.serverUrl);
        return;
      }catch{
        online.disconnect();
      }
    }
    renderOnlineConnection({
      status:'ready',
      detail:'Edgegap elegirá la región y levantará el servidor al buscar partida.',
    });
  }else if(automaticMatchmaking.hasPartialManagedConfig){
    renderOnlineConnection({
      status:'error',
      detail:'La configuración de Edgegap está incompleta: falta la URL o el token de Matchmaker.',
    });
  }else{
    await ensureOnlineConnection();
  }
}

function closeOnline(){
  clearTimeout(onlineStartTimer);
  scheduledOnlineMatchId=null;
  automaticMatchmaking.cancel();
  quickMatchPending=false;
  online.disconnect();
  state.onlineOpen=false;
  input.clear();
  game.mode='menu';
  game.clock.getDelta();
  elements.onlineScreen.classList.add('hidden');
  elements.menu.classList.remove('hidden');
  renderOnlineRoom(null,null);
  requestAnimationFrame(()=>focusInterfaceElement(elements.onlineButton));
}

function leaveOnlineGame(){
  clearTimeout(onlineStartTimer);
  scheduledOnlineMatchId=null;
  const hadOnlineGame=Boolean(game.onlineSession);
  online.leaveRoom();
  if(hadOnlineGame)game.backToMenu();
  automaticMatchmaking.cancel();
  online.disconnect();
}

function returnToOnlineRoom(){
  clearTimeout(onlineStartTimer);
  scheduledOnlineMatchId=null;
  const room=online.room;
  const isHost=room?.hostId===online.playerId;
  if(isHost&&room?.status==='finished')online.prepareRematch();
  game.returnToOnlineLobby();
  state.onlineOpen=true;
  state.localOpen=false;
  state.garageOpen=false;
  state.accountOpen=false;
  elements.hud.classList.add('hidden');
  elements.pause.classList.add('hidden');
  elements.results.classList.add('hidden');
  elements.menu.classList.add('hidden');
  elements.localScreen.classList.add('hidden');
  elements.garageScreen.classList.add('hidden');
  elements.accountScreen.classList.add('hidden');
  elements.onlineScreen.classList.remove('hidden');
  renderOnlineRoom(room,online.playerId);
  requestAnimationFrame(()=>focusInterfaceElement(elements.onlineReady));
}

function selectMap(id) {
  const map=MAPS.find((item)=>item.id===id)||MAPS[0];
  state.mapId=map.id;localStorage.setItem('toybox-map',map.id);
  elements.mapList.querySelectorAll('[data-map]').forEach((button)=>{
    const selected=button.dataset.map===map.id;button.classList.toggle('selected',selected);button.setAttribute('aria-selected',String(selected));
  });
  game.setMap(map.id);
  updateLocalSelectionSummary();
}

function formatMatchTime(seconds) {
  const total=Math.max(0,Math.ceil(seconds));
  return `${String(Math.floor(total/60)).padStart(2,'0')}:${String(total%60).padStart(2,'0')}`;
}

function formatScore(seconds) {
  return `${seconds.toFixed(1)}s`;
}

function renderTutorialHud(tutorial){
  if(!tutorial)return;
  const completed=Boolean(tutorial.completed);
  const step=tutorial.step;
  elements.tutorialGuide.classList.toggle('completed',completed);
  elements.tutorialCompleteCopy.classList.toggle('hidden',!completed);
  elements.tutorialInputs.classList.toggle('hidden',completed);
  elements.tutorialStepCount.textContent=completed
    ?`${String(tutorial.total).padStart(2,'0')} / ${String(tutorial.total).padStart(2,'0')}`
    :`${String(tutorial.stepIndex+1).padStart(2,'0')} / ${String(tutorial.total).padStart(2,'0')}`;
  elements.tutorialProgressBar.style.width=completed
    ?'100%'
    :`${Math.max(5,((tutorial.stepIndex+tutorial.progress)/tutorial.total)*100)}%`;
  if(completed){
    elements.tutorialStepIcon.textContent='✓';
    elements.tutorialStepLabel.textContent='CURSO COMPLETO';
    elements.tutorialStepTitle.textContent='LICENCIA TURBO';
    elements.tutorialStepCopy.textContent='Ya dominás los controles esenciales del auto.';
    elements.objectiveText.textContent='¡LICENCIA CONSEGUIDA! SEGUÍ PRACTICANDO O ABRÍ EL MENÚ';
    return;
  }
  if(!step)return;
  elements.tutorialStepIcon.textContent=String(tutorial.stepIndex+1).padStart(2,'0');
  elements.tutorialStepLabel.textContent='LECCIÓN ACTUAL';
  elements.tutorialStepTitle.textContent=step.title;
  elements.tutorialStepCopy.textContent=step.instruction;
  const tutorialKeys={
    accelerate:()=>keyCodeLabel(settings.controls.forward),
    steer:()=>`${keyCodeLabel(settings.controls.left)} / ${keyCodeLabel(settings.controls.right)}`,
    reverse:()=>keyCodeLabel(settings.controls.backward),
    handbrake:()=>keyCodeLabel(settings.controls.handbrake),
    jump:()=>`${keyCodeLabel(settings.controls.jump)} ×2 + WASD`,
    boost:()=>keyCodeLabel(settings.controls.boost),
    'air-control':()=>[
      settings.controls.forward,
      settings.controls.left,
      settings.controls.backward,
      settings.controls.right,
    ].map(keyCodeLabel).join(' / '),
    stabilize:()=>keyCodeLabel(settings.controls.stabilize),
    fire:()=>'LMB',
  };
  elements.tutorialKeyboardControl.textContent=tutorialKeys[step.id]?.()||step.keyboard;
  elements.tutorialGamepadControl.textContent=step.gamepad;
  elements.objectiveText.textContent=`LECCIÓN ${tutorial.stepIndex+1} DE ${tutorial.total} · ${step.title.toUpperCase()}`;
}

function updateHud(vehicle,match={type:'practice'}) {
  const speed=Math.round(Math.hypot(vehicle.velocity.x,vehicle.velocity.z)*8.4);
  const rupture=match.type==='rupture';
  elements.speedValue.textContent=String(Math.min(999,speed)).padStart(3,'0');
  elements.gearValue.textContent=vehicle.forwardSpeed<-.7?'R':speed<3?'N':String(Math.min(6,Math.max(1,Math.ceil(speed/31))));
  elements.nitroBar.style.width=`${vehicle.nitro}%`;elements.nitroPercent.textContent=`${Math.round(vehicle.nitro)}%`;
  const overcharged=(vehicle.nitroOverchargeTimer||0)>0;
  elements.nitroBar.parentElement.classList.toggle('overcharged',overcharged);
  elements.nitroBar.parentElement.classList.toggle('expiring',overcharged&&vehicle.nitroOverchargeTimer<1);
  const pending=(vehicle.powerupRevealTimer||0)>0;
  const powerup=POWERUP_DEFINITIONS[vehicle.powerupHeld];
  const active=vehicle.powerupShieldTimer>0
    ?POWERUP_DEFINITIONS[2]
    :vehicle.homingAmmoTimer>0
      ?POWERUP_DEFINITIONS[4]
      :overcharged?POWERUP_DEFINITIONS[1]:null;
  elements.powerupSlot.classList.toggle('empty',!pending&&!powerup&&!active);
  elements.powerupSlot.classList.toggle('roulette',pending);
  elements.powerupSlot.classList.toggle('active',Boolean(active));
  elements.powerupSlot.style.setProperty('--powerup-color',(powerup||active)?.color||'#ffffff');
  elements.powerupSymbol.textContent=pending?'?':(powerup||active)?.symbol||'—';
  elements.powerupName.textContent=pending?'ABRIENDO CAJA…':powerup?.shortLabel||active?.shortLabel||'VACÍO';
  const activeTimer=vehicle.powerupShieldTimer||vehicle.homingAmmoTimer||vehicle.nitroOverchargeTimer||0;
  elements.powerupHint.textContent=powerup
    ?`${keyCodeLabel(settings.controls.powerup)} / ↑ PARA USAR`
    :active?`${activeTimer.toFixed(1)} S`:'BUSCÁ UNA CAJA SORPRESA';
  const meterValue=rupture?match.instability:vehicle.health;
  elements.healthLabelText.textContent=rupture?'INESTABILIDAD':'INTEGRIDAD';
  elements.healthBar.style.width=`${meterValue}%`;elements.healthPercent.textContent=`${Math.round(meterValue)}%`;
  elements.healthPercent.style.color=rupture
    ?meterValue>72?'#ff7188':meterValue>38?'#ffd34f':'#65efff'
    :meterValue>55?'#7dff93':meterValue>25?'#ffd34f':'#ff7188';
  elements.airBadge.classList.toggle('hidden',vehicle.grounded);
  elements.airBadge.classList.toggle('dodge-ready',Boolean(vehicle.airDodgeAvailable));
  elements.airState.textContent=vehicle.airDodgeAvailable?'SALTO EVASIVO':'EN EL AIRE';
  elements.airTime.textContent=`${vehicle.airTime.toFixed(1)}s`;
  if(match.type==='tutorial'){
    renderTutorialHud(match.tutorial);
  }else if(match.type==='online'){
    elements.objectiveText.textContent=match.connected
      ?`ONLINE · ${match.participantCount} PILOTOS · PREPARANDO REGLAS DE PARTIDA`
      :'ESPERANDO SNAPSHOTS DEL SERVIDOR…';
  }else if(match.type==='rupture'){
    const phaseProgress=match.phase.duration>0
      ?Math.max(0,Math.min(1,match.phase.remaining/match.phase.duration))*100
      :0;
    elements.rupturePhase.textContent=match.phase.label;
    elements.ruptureTime.textContent=match.phase.id==='void'?'—':formatMatchTime(match.phase.remaining);
    elements.ruptureFuses.textContent=`${'◆'.repeat(match.fuses)}${'◇'.repeat(Math.max(0,2-match.fuses))}`;
    elements.rupturePlatform.textContent=`PISO ${match.platformIndex+1} / ${match.platformCount}`;
    elements.ruptureProgressBar.style.width=`${phaseProgress}%`;
    elements.ruptureSurvivors.textContent=`${match.survivors} / ${match.participantCount} AUTOS`;
    const routeActive=Boolean(match.route)
      &&['warning','transfer','collapse'].includes(match.phase.id)
      &&match.respawn<=0;
    const routeUrgent=routeActive
      &&(match.phase.id!=='warning'||match.phase.remaining<=1.7);
    elements.ruptureDirection.classList.toggle('hidden',!routeActive);
    elements.ruptureDirection.classList.toggle('urgent',routeUrgent);
    elements.hud.classList.toggle('rupture-route-active',routeActive);
    if(routeActive){
      elements.ruptureDirectionArrow.style.setProperty('--route-angle',`${match.route.angle}rad`);
      elements.ruptureDirectionAlert.textContent=match.phase.id==='collapse'
        ?'¡EL PISO SE CAE!'
        :match.phase.id==='transfer'
          ?'¡SALTÁ AHORA!'
          :'¡NUEVO PISO!';
      const distance=Math.max(0,Math.round(match.route.distance));
      const rise=Math.round(match.route.rise);
      elements.ruptureDirectionCopy.textContent=`${distance} M · ${rise>=0?'+':''}${rise} M ↑`;
    }
    elements.objectiveText.textContent=match.eliminated
      ?`ELIMINADO · ESPECTADOR${match.spectatorName?`: ${match.spectatorName}`:''}`
      :match.respawn>0
      ?`NUEVO FUSIBLE EN ${Math.ceil(match.respawn)}`
      :match.protection>0?'ATERRIZAJE PROTEGIDO · PREPARATE'
        :['warning','transfer','collapse'].includes(match.phase.id)
          ?`VOLÁ HACIA ${match.nextPlatformName||'EL SIGUIENTE PISO'}`
          :match.final?'MUERTE SÚBITA · EL PISO DESAPARECE DESDE AFUERA'
            :'DISPARÁ Y EMBESTÍ · MÁS INESTABILIDAD SIGNIFICA MÁS EMPUJE';
  }else if(match.type==='chase'){
    elements.chaseTime.textContent=formatMatchTime(match.remaining);
    elements.chaseTarget.textContent=match.pursuedIsPlayer?'¡VOS!':match.pursuedName;
    elements.chaseHud.classList.toggle('player-target',match.pursuedIsPlayer);
    elements.chaseScoreboard.innerHTML=match.scoreboard.slice(0,3).map((entry,index)=>`<span>${index+1}. ${entry.name} · ${formatScore(entry.seconds)}</span>`).join('');
    elements.chasePressureLabel.textContent=match.pursuedIsPlayer?'TU INESTABILIDAD':'INESTABILIDAD DEL OBJETIVO';
    elements.chasePressureBar.style.width=`${match.targetInstability}%`;
    elements.chasePressure.classList.toggle('danger',match.targetInstability>=72);
    elements.chasePressureStatus.textContent=match.playerNitroLocked?'¡NITRO BLOQUEADO!'
      :match.playerSlowed?'¡IMPACTO DEFENSIVO: RALENTIZADO!'
        :match.pursuedIsPlayer?'DISPARÁ A TUS PERSEGUIDORES PARA FRENARLOS':'DISPARÁ PARA BLOQUEARLE EL NITRO';
    elements.objectiveText.textContent=match.pursuedIsPlayer?'ESCAPÁ · LOS DISPAROS DEFENSIVOS EMPUJAN Y RALENTIZAN'
      :`ALCANZÁ O DESESTABILIZÁ A ${match.pursuedName}`;
  }else if(match.type==='battle'){
    elements.battleTime.textContent=formatMatchTime(match.remaining);
    elements.battleBlueScore.textContent=match.blueScore;
    elements.battleRedScore.textContent=match.redScore;
    elements.objectiveText.textContent=match.respawn>0
      ?`REAPARECÉS EN ${Math.ceil(match.respawn)}`
      :match.protection>0?'PROTECCIÓN DE REAPARICIÓN'
        :`DESTRUÍ AL EQUIPO ROJO · PRIMERO A ${match.killLimit}`;
  }else if(match.type==='ffa'){
    elements.ffaTime.textContent=match.overtime?'EXTRA':formatMatchTime(match.remaining);
    elements.ffaRank.textContent=`${match.playerRank} / ${match.participantCount}`;
    elements.ffaKills.textContent=`${match.playerStats?.kills||0} / ${match.killLimit}`;
    elements.ffaHud.classList.toggle('overtime',match.overtime);
    elements.ffaScoreboard.innerHTML=match.scoreboard.slice(0,3).map((entry,index)=>
      `<span>${index+1}. ${entry.name} · ${entry.kills} B</span>`).join('');
    elements.objectiveText.textContent=match.respawn>0
      ?`REAPARECÉS EN ${Math.ceil(match.respawn)}`
      :match.protection>0?'PROTECCIÓN DE REAPARICIÓN'
        :match.overtime?'MUERTE SÚBITA · LA PRÓXIMA BAJA DE UN LÍDER GANA'
          :`ELIMINÁ A TODOS · PRIMERO A ${match.killLimit}`;
  }
  drawMinimap(vehicle,match);
}

function updateAimHud(aim={visible:false}){
  const visible=Boolean(aim.visible)&&!elements.hud.classList.contains('hidden');
  elements.combatReticle.classList.toggle('hidden',!visible);
  if(!visible)return;
  elements.combatReticle.style.left=`${Math.round(aim.x)}px`;
  elements.combatReticle.style.top=`${Math.round(aim.y)}px`;
  elements.combatReticle.classList.toggle('locked',Boolean(aim.locked));
  elements.combatReticle.classList.toggle('confirmed',Boolean(aim.confirmed));
  elements.combatReticle.classList.toggle('blocked',Boolean(aim.blocked));
  elements.combatReticle.classList.toggle('assisted',Boolean(aim.assisted));
  elements.combatReticle.classList.toggle('precision',Boolean(aim.precision));
  elements.combatReticle.classList.toggle('offscreen',Boolean(aim.offscreen));
  elements.combatReticleLabel.textContent=aim.label||'CÁMARA LIBRE';
}

function drawMinimap(player,match={type:'practice'}) {
  const canvas=elements.minimap;const ctx=canvas.getContext('2d');const size=canvas.width;const world=game.world;
  ctx.clearRect(0,0,size,size);ctx.save();ctx.beginPath();ctx.arc(size/2,size/2,size/2-5,0,Math.PI*2);ctx.clip();
  ctx.fillStyle=world.colors.map;ctx.fillRect(0,0,size,size);
  const sx=size/world.width,sz=size/world.depth;
  ctx.strokeStyle=world.colors.line;ctx.globalAlpha=.28;ctx.lineWidth=1;
  for(let i=1;i<6;i+=1){ctx.beginPath();ctx.moveTo(i*size/6,0);ctx.lineTo(i*size/6,size);ctx.stroke();ctx.beginPath();ctx.moveTo(0,i*size/6);ctx.lineTo(size,i*size/6);ctx.stroke();}
  ctx.globalAlpha=.48;ctx.fillStyle='#2a2534';
  world.obstacles.forEach((o)=>ctx.fillRect((o.minX+world.width/2)*sx,(o.minZ+world.depth/2)*sz,(o.maxX-o.minX)*sx,(o.maxZ-o.minZ)*sz));
  game.vehicles.slice(1).forEach((bot)=>{
    const pursued=match.type==='chase'&&bot===game.chasePursued;
    const battleColor=match.type==='battle'?(bot.teamId==='blue'?'#49dff5':'#ff5d75')
      :match.type==='ffa'?'#c58cff':null;
    ctx.globalAlpha=bot.disabled ? .3 : 1;ctx.fillStyle=pursued?'#fff16a':battleColor||'#ff6d78';ctx.strokeStyle=pursued?'#ff6b3d':'transparent';ctx.lineWidth=2;
    ctx.beginPath();ctx.arc((bot.car.position.x+world.width/2)*sx,(bot.car.position.z+world.depth/2)*sz,pursued?5:3.2,0,Math.PI*2);ctx.fill();if(pursued)ctx.stroke();
  });
  const px=(player.car.position.x+world.width/2)*sx,pz=(player.car.position.z+world.depth/2)*sz;
  ctx.translate(px,pz);ctx.rotate(-player.yaw);ctx.globalAlpha=1;ctx.fillStyle='#fff16a';ctx.strokeStyle='#272232';ctx.lineWidth=2;ctx.beginPath();ctx.moveTo(0,-7);ctx.lineTo(5,6);ctx.lineTo(0,3);ctx.lineTo(-5,6);ctx.closePath();ctx.fill();ctx.stroke();
  ctx.restore();ctx.strokeStyle='rgba(255,255,255,.42)';ctx.lineWidth=4;ctx.beginPath();ctx.arc(size/2,size/2,size/2-4,0,Math.PI*2);ctx.stroke();
}

function showStunt(airTime) {
  clearTimeout(stuntTimer);elements.messageToast.textContent=airTime>1.6?'¡VUELO DE JUGUETE!':'¡BUEN SALTO!';elements.messageToast.classList.remove('hidden');
  stuntTimer=setTimeout(()=>elements.messageToast.classList.add('hidden'),1300);
}

function showChaseTag(event) {
  clearTimeout(stuntTimer);
  elements.messageToast.textContent=event.pursuedIsPlayer?'¡AHORA TE PERSIGUEN A VOS!':`¡AHORA ESCAPA ${event.pursuedName}!`;
  elements.messageToast.classList.remove('hidden');
  stuntTimer=setTimeout(()=>elements.messageToast.classList.add('hidden'),1700);
}

function showBattleEvent(event) {
  clearTimeout(stuntTimer);
  if(event.killerIsPlayer)elements.messageToast.textContent=`¡ELIMINASTE A ${event.victimName}!`;
  else if(event.victimIsPlayer)elements.messageToast.textContent=`${event.killerName} TE ELIMINÓ`;
  else if(event.playerAssist)elements.messageToast.textContent=`¡ASISTENCIA CONTRA ${event.victimName}!`;
  else elements.messageToast.textContent=`${event.killerName} ELIMINÓ A ${event.victimName}`;
  elements.messageToast.classList.remove('hidden');
  stuntTimer=setTimeout(()=>elements.messageToast.classList.add('hidden'),1450);
}

function showRuptureEvent(event){
  clearTimeout(stuntTimer);
  const messages={
    reveal:'¡APARECIÓ EL SIGUIENTE PISO!',
    collapse:'¡LA PLATAFORMA SE DERRUMBA!',
    'final-warning':'¡ÚLTIMO PISO · PREPARATE!',
    landed:`¡ATERRIZAJE EN EL PISO ${event.platform||''}!`,
  };
  if(event.type==='fuse'){
    elements.messageToast.textContent=event.isPlayer
      ?`¡PERDISTE UN FUSIBLE · TE QUEDA ${event.fuses}!`
      :`${event.name} PERDIÓ UN FUSIBLE`;
  }else if(event.type==='eliminated'){
    elements.messageToast.textContent=event.isPlayer
      ?'¡TE QUEDASTE SIN FUSIBLES!'
      :`¡${event.name} QUEDÓ ELIMINADO!`;
  }else elements.messageToast.textContent=messages[event.type]||'';
  if(!elements.messageToast.textContent)return;
  elements.messageToast.classList.remove('hidden');
  stuntTimer=setTimeout(()=>elements.messageToast.classList.add('hidden'),1700);
}

function showCameraDistance(preset){
  clearTimeout(stuntTimer);
  elements.messageToast.textContent=`CÁMARA ${preset.label}`;
  elements.messageToast.classList.remove('hidden');
  stuntTimer=setTimeout(()=>elements.messageToast.classList.add('hidden'),1200);
}

function showResults(match) {
  elements.hud.classList.add('hidden');
  elements.pause.classList.add('hidden');
  elements.postMatch.classList.add('hidden');
  elements.exitConfirmation.classList.add('hidden');
  state.exitConfirmOpen=false;
  confirmedExitAction=null;
  exitConfirmReturnFocus=null;
  if(match.online&&playerAccount.snapshot().status==='signed-in'){
    setTimeout(()=>playerAccount.refreshEconomy().catch(()=>{}),1500);
  }
  const battle=match.type==='battle';
  const freeForAll=match.type==='ffa';
  const rupture=match.type==='rupture';
  elements.results.classList.toggle('battle-results',battle);
  elements.results.classList.toggle('ffa-results',freeForAll);
  elements.resultsRestart.textContent=match.online
    ?online.room?.hostId===online.playerId?'PREPARAR REVANCHA':'VOLVER A LA SALA'
    :'JUGAR DE NUEVO';
  elements.resultsMenu.textContent=match.online?'VOLVER A SALAS ONLINE':'VOLVER AL MENÚ PRINCIPAL';
  if(rupture){
    const playerWon=Boolean(match.winner?.isPlayer);
    elements.resultsEyebrow.textContent='FIN DE RUPTURA TURBO';
    elements.resultsTitle.textContent=playerWon?'¡SOS EL ÚLTIMO AUTO!':`${match.winner?.name||'UN RIVAL'} SOBREVIVIÓ`;
    elements.resultsCopy.textContent=playerWon
      ?'Dominaste los saltos, los impactos y el derrumbe final.'
      :`Llegaste hasta el piso ${match.scoreboard.find((entry)=>entry.isPlayer)?.platform||1}.`;
    elements.resultsScoreboard.innerHTML=match.scoreboard.map((entry,index)=>`
      <div class="result-row${entry.isPlayer?' is-player':''}">
        <span>${String(index+1).padStart(2,'0')}</span>
        <b>${entry.name}</b>
        <strong>PISO ${entry.platform} · ${entry.fuses} ${entry.fuses===1?'FUSIBLE':'FUSIBLES'}${entry.eliminated?' · FUERA':''}</strong>
      </div>
    `).join('');
    elements.results.classList.remove('hidden');
    requestAnimationFrame(()=>focusInterfaceElement(elements.resultsRestart));
    return;
  }
  if(battle){
    const tied=!match.winnerTeam;
    elements.resultsEyebrow.textContent='FIN DE LA BATALLA';
    elements.resultsTitle.textContent=tied?'¡EMPATE!':match.playerWon?'¡VICTORIA AZUL!':'VICTORIA ROJA';
    elements.resultsCopy.textContent=tied
      ?`Ambos equipos terminaron ${match.blueScore} a ${match.redScore}.`
      :match.playerWon?`Tu equipo ganó ${match.blueScore} a ${match.redScore}.`:`El equipo rojo ganó ${match.redScore} a ${match.blueScore}.`;
    const renderTeam=(teamId,label)=>`
      <div class="result-team ${teamId}">
        <header><b>${label}</b><strong>${teamId==='blue'?match.blueScore:match.redScore}</strong></header>
        ${match.teams[teamId].map((entry)=>`
          <div class="result-row${entry.isPlayer?' is-player':''}">
            <b>${entry.name}</b><span>${entry.kills} B · ${entry.assists} A</span><strong>${entry.deaths} M</strong>
          </div>
        `).join('')}
      </div>`;
    elements.resultsScoreboard.innerHTML=renderTeam('blue','EQUIPO AZUL')+renderTeam('red','EQUIPO ROJO');
    elements.results.classList.remove('hidden');
    requestAnimationFrame(()=>focusInterfaceElement(elements.resultsRestart));
    return;
  }
  if(freeForAll){
    const playerWon=Boolean(match.winner?.isPlayer);
    elements.resultsEyebrow.textContent='FIN DEL TODOS CONTRA TODOS';
    elements.resultsTitle.textContent=playerWon?'¡GANASTE!':`${match.winner?.name||'UN RIVAL'} GANÓ`;
    elements.resultsCopy.textContent=playerWon
      ?`Terminaste primero con ${match.winner?.kills||0} eliminaciones.`
      :`${match.winner?.name||'Un rival'} dominó la arena con ${match.winner?.kills||0} eliminaciones.`;
    elements.resultsScoreboard.innerHTML=match.scoreboard.map((entry,index)=>`
      <div class="result-row${entry.isPlayer?' is-player':''}">
        <span>${String(index+1).padStart(2,'0')}</span><b>${entry.name}</b><strong>${entry.kills} B · ${entry.assists} A · ${entry.deaths} M</strong>
      </div>
    `).join('');
    elements.results.classList.remove('hidden');
    requestAnimationFrame(()=>focusInterfaceElement(elements.resultsRestart));
    return;
  }
  elements.resultsEyebrow.textContent='FIN DE LA PERSECUCIÓN';
  const playerWon=Boolean(match.winner?.isPlayer);
  elements.resultsTitle.textContent=playerWon?'¡GANASTE!':`${match.winner?.name||'UN RIVAL'} GANÓ`;
  elements.resultsCopy.textContent=playerWon?'Fuiste quien más tiempo logró escapar.':'Esta vez otro autito acumuló más tiempo como perseguido.';
  elements.resultsScoreboard.innerHTML=match.scoreboard.map((entry,index)=>`
    <div class="result-row${entry.isPlayer?' is-player':''}">
      <span>${String(index+1).padStart(2,'0')}</span><b>${entry.name}</b><strong>${formatScore(entry.seconds)}</strong>
    </div>
  `).join('');
  elements.results.classList.remove('hidden');
  requestAnimationFrame(()=>focusInterfaceElement(elements.resultsRestart));
}

function togglePause() {
  if(game.mode==='online-game')game.pauseOnline(!game.onlinePaused);
  else if(game.mode==='game')game.pause(true);else if(game.mode==='paused')game.pause(false);
}

function gamepadScreenContext(){
  if(virtualKeyboardState)return 'virtual-keyboard';
  if(state.purchaseOpen)return 'confirm-purchase';
  if(state.exitConfirmOpen)return 'confirm-exit';
  if(game.mode==='results')return 'results';
  if(state.settingsOpen)return 'settings';
  if(game.mode==='paused'||game.onlinePaused)return 'pause';
  if(state.localOpen)return 'local';
  if(state.accountOpen)return 'account';
  if(state.garageOpen)return 'garage';
  if(state.onlineOpen)return 'online';
  if(game.mode==='menu')return 'menu';
  return 'game';
}

function updateGamepadHints(){
  const context=gamepadScreenContext();
  const hintKey=`${interfaceInputDevice}:${context}`;
  if(hintKey===gamepadHintContext)return;
  gamepadHintContext=hintKey;
  elements.gamepadHints.dataset.context=context;
  const gamepadHints={
    menu:[['A','SELECCIONAR'],['X','GARAGE'],['Y','ONLINE']],
    local:[['A','SELECCIONAR'],['B','VOLVER']],
    account:[['A','SELECCIONAR'],['B','VOLVER']],
    settings:[['A','SELECCIONAR'],['←/→','AJUSTAR'],['B','VOLVER']],
    garage:[['A','ELEGIR / EQUIPAR'],['LB/RB','CATEGORÍA'],['B','VOLVER'],['RS','CÁMARA']],
    online:[['A','SELECCIONAR'],['←/→','CAMBIAR OPCIÓN'],['B','VOLVER']],
    pause:[['A','SELECCIONAR'],['B','CONTINUAR']],
    results:[['A','SELECCIONAR'],['B','SALIR']],
    'confirm-purchase':[['A','CONFIRMAR'],['B','CANCELAR']],
    'confirm-exit':[['A','CONFIRMAR'],['B','CANCELAR']],
    'virtual-keyboard':[['A','ESCRIBIR'],['B','CANCELAR']],
  };
  const keyboardHints={
    menu:[['↑↓←→','NAVEGAR'],['ENTER','SELECCIONAR']],
    local:[['↑↓←→','NAVEGAR'],['ENTER','SELECCIONAR'],['ESC','VOLVER']],
    account:[['TAB / ↑↓','NAVEGAR'],['ENTER','SELECCIONAR'],['ESC','VOLVER']],
    settings:[['↑↓','NAVEGAR'],['←/→','AJUSTAR'],['ESC','VOLVER']],
    garage:[['↑↓←→','NAVEGAR'],['ENTER','EQUIPAR'],['Q / E','CATEGORÍA'],['ESC','VOLVER']],
    online:[['TAB / ↑↓','NAVEGAR'],['←/→','CAMBIAR OPCIÓN'],['ESC','VOLVER']],
    pause:[['↑ / ↓','NAVEGAR'],['ENTER','SELECCIONAR'],['ESC','CONTINUAR']],
    results:[['↑ / ↓','NAVEGAR'],['ENTER','SELECCIONAR'],['ESC','SALIR']],
    'confirm-purchase':[['← / →','ELEGIR'],['ENTER','CONFIRMAR'],['ESC','CANCELAR']],
    'confirm-exit':[['← / →','ELEGIR'],['ENTER','CONFIRMAR'],['ESC','CANCELAR']],
    'virtual-keyboard':[['MOUSE','ESCRIBIR'],['ENTER','ACEPTAR'],['ESC','CANCELAR']],
  };
  const hints=(interfaceInputDevice==='gamepad'?gamepadHints:keyboardHints)[context]||[];
  elements.gamepadHints.innerHTML=hints.map(([button,label])=>`<span><kbd>${button}</kbd>${label}</span>`).join('');
  elements.gamepadHints.classList.toggle('hidden',!hints.length);
}

function setGamepadNavigationActive(active){
  gamepadNavigationActive=Boolean(active);
  document.body.classList.toggle('gamepad-active',gamepadNavigationActive);
  if(!gamepadNavigationActive){
    gamepadFocusedElement=null;
    elements.gamepadFocusRing.classList.remove('visible');
  }
  gamepadHintContext='';
  updateGamepadHints();
}

function setInterfaceInputDevice(device,{navigation=true}={}){
  interfaceInputDevice=device==='gamepad'?'gamepad':'keyboard-mouse';
  keyboardNavigationActive=interfaceInputDevice==='keyboard-mouse'&&Boolean(navigation);
  document.body.classList.toggle('keyboard-navigation-active',keyboardNavigationActive);
  setGamepadNavigationActive(interfaceInputDevice==='gamepad'&&Boolean(navigation));
  gamepadHintContext='';
  updateGamepadHints();
}

function gamepadFocusables() {
  const selector='button:not([disabled]),select:not([disabled]),input:not([disabled]):not([type="hidden"]),[tabindex]:not([tabindex="-1"])';
  const showingPause=game.mode==='paused'||game.onlinePaused;
  const container=virtualKeyboardState?elements.virtualKeyboard:state.purchaseOpen?elements.purchaseConfirmation:state.exitConfirmOpen?elements.exitConfirmation
    :game.mode==='results'?elements.results:state.settingsOpen?elements.settingsScreen:showingPause?elements.pause
    :state.localOpen?elements.localScreen:state.accountOpen?elements.accountScreen:state.onlineOpen?elements.onlineScreen:state.garageOpen?elements.garageScreen:elements.menu;
  if(!state.purchaseOpen&&!state.exitConfirmOpen&&game.mode!=='results'&&!state.settingsOpen&&!showingPause&&game.mode!=='menu'&&game.mode!=='garage'&&game.mode!=='online'&&!state.localOpen&&!state.accountOpen)return [];
  return [...container.querySelectorAll(selector)].filter((element)=>{
    const rect=element.getBoundingClientRect();
    return rect.width>0&&rect.height>0
      &&element.getAttribute('aria-hidden')!=='true'
      &&!element.closest('.hidden,[hidden],[aria-hidden="true"]');
  });
}

function defaultGamepadFocusable(buttons=gamepadFocusables()){
  let preferred=null;
  if(virtualKeyboardState)preferred=elements.virtualKeyboardKeys.querySelector('.virtual-keyboard-key');
  else if(state.purchaseOpen)preferred=elements.purchaseConfirmAccept.disabled
    ?elements.purchaseConfirmCancel:elements.purchaseConfirmAccept;
  else if(state.exitConfirmOpen)preferred=elements.exitConfirmCancel;
  else if(game.mode==='results')preferred=elements.resultsRestart;
  else if(state.settingsOpen)preferred=elements.settingsDone;
  else if(game.mode==='paused'||game.onlinePaused)preferred=elements.resumeButton;
  else if(state.localOpen)preferred=elements.localModeList.querySelector('.selected')||elements.localStart;
  else if(state.accountOpen)preferred=playerAccount.snapshot().status==='signed-in'
    ?elements.accountDisplayName
    :accountAuthMode==='register'?elements.accountRegisterName:elements.accountLoginEmail;
  else if(state.onlineOpen)preferred=online.room?elements.onlineReady:elements.onlineQuickMatch;
  else if(state.garageOpen)preferred=elements.carList.querySelector('.selected')||elements.garageClose;
  else preferred=elements.localButton;
  return buttons.includes(preferred)?preferred:buttons[0]||null;
}

function focusInterfaceElement(element,{scroll=true,refresh=true}={}){
  if(!element||!element.isConnected)return null;
  gamepadFocusedElement=element;
  try{element.focus({preventScroll:true});}catch{element.focus();}
  if(scroll)element.scrollIntoView?.({block:'nearest',inline:'nearest'});
  if(refresh)updateGamepadFocusRing();
  return element;
}

function updateGamepadFocusRing(){
  updateGamepadHints();
  if(!gamepadNavigationActive||interfaceInputDevice!=='gamepad'||gamepadScreenContext()==='game'){
    elements.gamepadFocusRing.classList.remove('visible');
    return;
  }
  const focusables=gamepadFocusables();
  let current=focusables.includes(document.activeElement)?document.activeElement:null;
  if(!current&&focusables.includes(gamepadFocusedElement))current=gamepadFocusedElement;
  if(!current)current=focusInterfaceElement(defaultGamepadFocusable(focusables),{scroll:false,refresh:false});
  if(!current){elements.gamepadFocusRing.classList.remove('visible');return;}
  gamepadFocusedElement=current;
  const rect=current.getBoundingClientRect();
  if(rect.width<=0||rect.height<=0){elements.gamepadFocusRing.classList.remove('visible');return;}
  const padding=5;
  elements.gamepadFocusRing.style.transform=`translate3d(${rect.left-padding}px,${rect.top-padding}px,0)`;
  elements.gamepadFocusRing.style.width=`${rect.width+padding*2}px`;
  elements.gamepadFocusRing.style.height=`${rect.height+padding*2}px`;
  elements.gamepadFocusRing.style.borderRadius=`${Math.min(20,Math.max(9,rect.height*.2))}px`;
  elements.gamepadFocusRing.classList.add('visible');
}

function changeSelectOption(select,direction){
  if(!(select instanceof HTMLSelectElement)||!select.options.length)return false;
  const next=Math.min(select.options.length-1,Math.max(0,select.selectedIndex+direction));
  if(next===select.selectedIndex)return false;
  select.selectedIndex=next;
  select.dispatchEvent(new Event('change',{bubbles:true}));
  return true;
}

function changeRangeValue(inputElement,direction){
  if(!(inputElement instanceof HTMLInputElement)||inputElement.type!=='range')return false;
  const minimum=Number(inputElement.min)||0;
  const maximum=Number(inputElement.max)||100;
  const step=Math.max(.01,Number(inputElement.step)||1);
  const navigationStep=Math.max(step,(maximum-minimum)/20);
  const current=Number(inputElement.value)||0;
  const rawNext=current+navigationStep*direction;
  const next=Math.min(maximum,Math.max(minimum,Math.round(rawNext/step)*step));
  if(next===current)return true;
  inputElement.value=String(next);
  inputElement.dispatchEvent(new Event('input',{bubbles:true}));
  return true;
}

function changeCheckboxValue(inputElement,direction){
  if(!(inputElement instanceof HTMLInputElement)||inputElement.type!=='checkbox')return false;
  const next=direction>0;
  if(inputElement.checked===next)return true;
  inputElement.checked=next;
  inputElement.dispatchEvent(new Event('change',{bubbles:true}));
  return true;
}

function moveGamepadFocus(horizontal,vertical) {
  const buttons=gamepadFocusables();
  if(!buttons.length)return;
  let current=buttons.includes(document.activeElement)?document.activeElement:null;
  if(!current){
    current=defaultGamepadFocusable(buttons);
    focusInterfaceElement(current);
  }
  if(horizontal){
    const direction=horizontal>0?1:-1;
    if(changeRangeValue(current,direction)||changeSelectOption(current,direction)||changeCheckboxValue(current,direction)){
      updateGamepadFocusRing();
      return;
    }
  }
  const currentRect=current.getBoundingClientRect();
  const originX=currentRect.left+currentRect.width/2;
  const originY=currentRect.top+currentRect.height/2;
  let best=null;
  let bestScore=Infinity;
  buttons.forEach((candidate)=>{
    if(candidate===current)return;
    const rect=candidate.getBoundingClientRect();
    const dx=rect.left+rect.width/2-originX;
    const dy=rect.top+rect.height/2-originY;
    const forward=dx*horizontal+dy*vertical;
    if(forward<=4)return;
    const lateral=Math.abs(dx*vertical-dy*horizontal);
    const score=forward+lateral*2.4;
    if(score<bestScore){bestScore=score;best=candidate;}
  });
  focusInterfaceElement(best);
}

function cycleGarageCategory(direction){
  const tabs=[...elements.cosmeticTabs.querySelectorAll('button:not([disabled])')];
  if(!tabs.length)return;
  const selected=tabs.findIndex((button)=>button.dataset.slot===state.cosmeticSlot);
  const next=tabs[(Math.max(0,selected)+direction+tabs.length)%tabs.length];
  next.click();
  focusInterfaceElement(next);
}

function isTextEntryElement(element){
  return element instanceof HTMLInputElement
    &&['text','search','email','password'].includes(element.type);
}

function virtualKeyboardInputLabel(inputElement){
  return inputElement.closest('label')?.querySelector('span')?.textContent?.trim()
    ||inputElement.getAttribute('aria-label')
    ||inputElement.placeholder
    ||'CAMPO DE TEXTO';
}

function renderVirtualKeyboard(){
  if(!virtualKeyboardState)return;
  const {input,uppercase}=virtualKeyboardState;
  const restricted=input===elements.onlineRoomCodeInput;
  const keyButton=(character)=>`<button class="virtual-keyboard-key" type="button" data-virtual-character="${safeHtml(character)}">${safeHtml(character)}</button>`;
  const letterRow=(characters)=>characters.split('').map((letter)=>keyButton(uppercase?letter:letter.toLowerCase())).join('');
  elements.virtualKeyboardKeys.innerHTML=`
    <div class="virtual-keyboard-row">${[...'1234567890'].map(keyButton).join('')}<button class="virtual-keyboard-key wide accent" type="button" data-virtual-action="backspace">⌫</button></div>
    <div class="virtual-keyboard-row">${letterRow('QWERTYUIOP')}${restricted?'':keyButton('@')}</div>
    <div class="virtual-keyboard-row">${letterRow('ASDFGHJKL')}${restricted?'':keyButton('.')}${restricted?'':keyButton('-')}</div>
    <div class="virtual-keyboard-row">${restricted?'':`<button class="virtual-keyboard-key wide" type="button" data-virtual-action="shift">${uppercase?'abc':'ABC'}</button>`}${letterRow('ZXCVBNM')}${restricted?'':keyButton('_')}${restricted?'':keyButton('!')}${restricted?'':keyButton('?')}</div>
    <div class="virtual-keyboard-row">${restricted?'':`<button class="virtual-keyboard-key space" type="button" data-virtual-character=" ">ESPACIO</button>`}<button class="virtual-keyboard-key wide" type="button" data-virtual-action="clear">BORRAR TODO</button></div>
  `;
  elements.virtualKeyboardValue.textContent=input.type==='password'
    ?'•'.repeat(input.value.length)
    :input.value;
}

function updateVirtualKeyboardInput(value){
  if(!virtualKeyboardState)return;
  const input=virtualKeyboardState.input;
  const maximum=Number(input.maxLength)>0?Number(input.maxLength):128;
  let next=String(value??'').slice(0,maximum);
  if(input===elements.onlineRoomCodeInput)next=next.toUpperCase().replace(/[^A-Z0-9]/g,'').slice(0,5);
  input.value=next;
  input.dispatchEvent(new Event('input',{bubbles:true}));
  elements.virtualKeyboardValue.textContent=input.type==='password'?'•'.repeat(next.length):next;
}

function openVirtualKeyboard(inputElement){
  if(!isTextEntryElement(inputElement))return false;
  virtualKeyboardState={
    input:inputElement,
    originalValue:inputElement.value,
    uppercase:inputElement===elements.onlineRoomCodeInput,
    returnFocus:inputElement,
  };
  inputElement.blur();
  elements.virtualKeyboardLabel.textContent=virtualKeyboardInputLabel(inputElement);
  elements.virtualKeyboard.classList.remove('hidden');
  renderVirtualKeyboard();
  gamepadHintContext='';
  requestAnimationFrame(()=>focusInterfaceElement(defaultGamepadFocusable()));
  return true;
}

function closeVirtualKeyboard({accept=true}={}){
  if(!virtualKeyboardState)return;
  const {input:inputElement,originalValue,returnFocus}=virtualKeyboardState;
  if(!accept)updateVirtualKeyboardInput(originalValue);
  else inputElement.dispatchEvent(new Event('change',{bubbles:true}));
  virtualKeyboardState=null;
  elements.virtualKeyboard.classList.add('hidden');
  input.clear();
  gamepadHintContext='';
  requestAnimationFrame(()=>focusInterfaceElement(returnFocus));
}

elements.virtualKeyboardKeys.addEventListener('click',(event)=>{
  if(!virtualKeyboardState)return;
  const button=event.target.closest('button');
  if(!button)return;
  const character=button.dataset.virtualCharacter;
  const action=button.dataset.virtualAction;
  if(character!==undefined)updateVirtualKeyboardInput(`${virtualKeyboardState.input.value}${character}`);
  else if(action==='backspace')updateVirtualKeyboardInput(virtualKeyboardState.input.value.slice(0,-1));
  else if(action==='clear')updateVirtualKeyboardInput('');
  else if(action==='shift'){
    virtualKeyboardState.uppercase=!virtualKeyboardState.uppercase;
    renderVirtualKeyboard();
    requestAnimationFrame(()=>focusInterfaceElement(elements.virtualKeyboardKeys.querySelector('[data-virtual-action="shift"]')));
  }
});
elements.virtualKeyboardCancel.addEventListener('click',()=>closeVirtualKeyboard({accept:false}));
elements.virtualKeyboardDone.addEventListener('click',()=>closeVirtualKeyboard({accept:true}));

function activateInterfaceElement(element,{gamepad=false}={}){
  if(!element)return false;
  if(gamepad&&isTextEntryElement(element))return openVirtualKeyboard(element);
  if(element instanceof HTMLSelectElement)return changeSelectOption(element,1);
  element.click?.();
  return true;
}

function navigateInterfaceBack(){
  if(virtualKeyboardState){closeVirtualKeyboard({accept:false});return true;}
  if(state.purchaseOpen){closePurchaseConfirmation();return true;}
  if(state.exitConfirmOpen){closeExitConfirmation();return true;}
  if(state.settingsOpen){closeSettings();return true;}
  if(state.localOpen){closeLocal();return true;}
  if(state.accountOpen){closeAccount();return true;}
  if(state.onlineOpen){closeOnline();return true;}
  if(state.garageOpen){closeGarage();return true;}
  if(game.mode==='online-game'){togglePause();return true;}
  if(game.mode==='results'){elements.resultsMenu.click();return true;}
  if(game.mode==='game'||game.mode==='paused'){togglePause();return true;}
  return false;
}

function updateGamepadNavigation() {
  const pad=input.pollGamepad();
  if(!pad){
    if(gamepadNavigationActive)setInterfaceInputDevice('keyboard-mouse',{navigation:false});
    requestAnimationFrame(updateGamepadNavigation);
    return;
  }
  if(input.consumeGamepadActivity())setInterfaceInputDevice('gamepad');
  if(virtualKeyboardState||state.purchaseOpen||state.exitConfirmOpen){
    if(input.consumeGamepad('ui-left'))moveGamepadFocus(-1,0);
    if(input.consumeGamepad('ui-right'))moveGamepadFocus(1,0);
    if(input.consumeGamepad('ui-up'))moveGamepadFocus(0,-1);
    if(input.consumeGamepad('ui-down'))moveGamepadFocus(0,1);
    if(input.consumeGamepad('confirm')){
      const buttons=gamepadFocusables();
      const active=buttons.includes(document.activeElement)
        ?document.activeElement
        :defaultGamepadFocusable(buttons);
      focusInterfaceElement(active);
      input.rumble({duration:55,weakMagnitude:.2,strongMagnitude:.08,priority:.5,key:'ui-confirm',minInterval:45});
      activateInterfaceElement(active,{gamepad:true});
    }
    if(input.consumeGamepad('cancel')||input.consumeGamepad('pause'))navigateInterfaceBack();
    updateGamepadFocusRing();
    requestAnimationFrame(updateGamepadNavigation);
    return;
  }
  if(game.mode==='menu'||game.mode==='garage'||game.mode==='online'||game.mode==='paused'||game.mode==='results'||game.onlinePaused||state.localOpen||state.accountOpen||state.settingsOpen){
    if(game.mode==='menu'&&!state.localOpen&&!state.garageOpen&&!state.onlineOpen&&!state.accountOpen&&!state.settingsOpen&&input.consumeGamepad('handbrake')){
      setInterfaceInputDevice('gamepad');elements.garageOpen.click();requestAnimationFrame(updateGamepadNavigation);return;
    }
    if(game.mode==='menu'&&!state.localOpen&&!state.garageOpen&&!state.onlineOpen&&!state.accountOpen&&!state.settingsOpen&&input.consumeGamepad('targetLock')){
      setInterfaceInputDevice('gamepad');elements.onlineButton.click();requestAnimationFrame(updateGamepadNavigation);return;
    }
    if(state.garageOpen&&input.consumeGamepad('tabPrev'))cycleGarageCategory(-1);
    if(state.garageOpen&&input.consumeGamepad('tabNext'))cycleGarageCategory(1);
    if(input.consumeGamepad('ui-left'))moveGamepadFocus(-1,0);
    if(input.consumeGamepad('ui-right'))moveGamepadFocus(1,0);
    if(input.consumeGamepad('ui-up'))moveGamepadFocus(0,-1);
    if(input.consumeGamepad('ui-down'))moveGamepadFocus(0,1);
    if(input.consumeGamepad('confirm')){
      const buttons=gamepadFocusables();
      const active=buttons.includes(document.activeElement)?document.activeElement:defaultGamepadFocusable(buttons);
      focusInterfaceElement(active);
      input.rumble({duration:55,weakMagnitude:.2,strongMagnitude:.08,priority:.5,key:'ui-confirm',minInterval:45});
      activateInterfaceElement(active,{gamepad:true});
    }
    if(input.consumeGamepad('cancel')||input.consumeGamepad('pause'))navigateInterfaceBack();
  }
  updateGamepadFocusRing();
  requestAnimationFrame(updateGamepadNavigation);
}

window.addEventListener('pointerdown',()=>setInterfaceInputDevice('keyboard-mouse',{navigation:false}),true);
window.addEventListener('turbo-crown-input-device',(event)=>{
  const device=event.detail?.device;
  if(device==='gamepad')setInterfaceInputDevice('gamepad');
  else if(gamepadScreenContext()==='game')setInterfaceInputDevice('keyboard-mouse',{navigation:false});
});
window.addEventListener('focusin',(event)=>{
  if(!gamepadFocusables().includes(event.target))return;
  gamepadFocusedElement=event.target;
  updateGamepadFocusRing();
});

elements.settingsButton.addEventListener('click',()=>{
  audio.ensure();
  audio.uiBlip(430,.08,'triangle',.045);
  openSettings('menu');
});
elements.settingsBack.addEventListener('click',closeSettings);
elements.settingsDone.addEventListener('click',closeSettings);
elements.pauseSettingsButton.addEventListener('click',()=>openSettings('pause'));
elements.settingsLanguage.addEventListener('change',()=>{
  settings.language=elements.settingsLanguage.value;
  applySettings();
});

const volumeControls=[
  [elements.settingsMasterVolume,'master'],
  [elements.settingsMusicVolume,'music'],
  [elements.settingsEffectsVolume,'effects'],
];
volumeControls.forEach(([control,key])=>{
  control.addEventListener('input',()=>{
    settings.audio[key]=Number(control.value);
    applySettings();
  });
});
elements.settingsEffectsVolume.addEventListener('change',()=>{
  audio.ensure();
  audio.uiBlip(410,.08,'triangle',.055);
});
elements.settingsCameraShake.addEventListener('input',()=>{
  settings.gameplay.cameraShake=Number(elements.settingsCameraShake.value);
  applySettings();
});
elements.settingsControllerVibration.addEventListener('change',()=>{
  settings.gameplay.controllerVibration=elements.settingsControllerVibration.checked;
  applySettings();
  input.rumble({
    duration:180,weakMagnitude:.34,strongMagnitude:.5,priority:2,key:'settings-haptics',
  });
});
elements.settingsControllerVibrationStrength.addEventListener('input',()=>{
  settings.gameplay.controllerVibrationStrength=Number(elements.settingsControllerVibrationStrength.value);
  applySettings();
  input.rumble({
    duration:110,weakMagnitude:.3,strongMagnitude:.42,priority:2,
    key:'settings-haptics-strength',minInterval:85,
  });
});
elements.settingsMouseSensitivity.addEventListener('input',()=>{
  settings.gameplay.mouseSensitivity=Number(elements.settingsMouseSensitivity.value);
  applySettings();
});
elements.settingsInvertMouseY.addEventListener('change',()=>{
  settings.gameplay.invertMouseY=elements.settingsInvertMouseY.checked;
  applySettings();
});
elements.settingsControllerAimSensitivity.addEventListener('input',()=>{
  settings.gameplay.controllerAimSensitivity=Number(elements.settingsControllerAimSensitivity.value);
  applySettings();
});
const mouseBindingControls=[
  [elements.settingsMouseFire,'fireButton'],
  [elements.settingsMouseCameraControl,'cameraControlButton'],
  [elements.settingsMouseCameraReverse,'cameraReverseButton'],
];
mouseBindingControls.forEach(([control,key])=>control.addEventListener('change',()=>{
  const previous=settings.mouse[key];
  const next=Number(control.value);
  const conflict=Object.keys(settings.mouse).find((candidate)=>candidate!==key&&settings.mouse[candidate]===next);
  if(conflict)settings.mouse[conflict]=previous;
  settings.mouse[key]=next;
  applySettings();
}));
elements.settingsKeyBindings.addEventListener('click',(event)=>{
  const button=event.target.closest('[data-binding-action]');
  if(!button)return;
  capturingBindingAction=button.dataset.bindingAction;
  input.enabled=false;
  input.clear();
  renderSettings();
  button.focus();
});
window.addEventListener('keydown',(event)=>{
  if(!capturingBindingAction)return;
  event.preventDefault();
  event.stopImmediatePropagation();
  if(event.code==='Escape'){
    capturingBindingAction=null;
    input.enabled=true;
    renderSettings();
    return;
  }
  if(['Tab','MetaLeft','MetaRight'].includes(event.code)){
    elements.settingsBindingMessage.textContent='Esa tecla se reserva para navegar por la interfaz. Elegí otra.';
    return;
  }
  const action=capturingBindingAction;
  const previousCode=settings.controls[action];
  const conflictingAction=Object.keys(settings.controls).find((candidate)=>
    candidate!==action&&settings.controls[candidate]===event.code,
  );
  if(conflictingAction)settings.controls[conflictingAction]=previousCode;
  settings.controls[action]=event.code;
  capturingBindingAction=null;
  input.enabled=true;
  applySettings();
},true);
elements.settingsReset.addEventListener('click',()=>{
  capturingBindingAction=null;
  input.enabled=true;
  settings=resetGameSettings(localStorage);
  applySettings({persist:false});
  audio.ensure();
  audio.uiBlip(260,.14,'sawtooth',.07);
});

async function setFullscreenState(enabled){
  try{
    if(window.toyboxDesktop){
      const current=window.toyboxDesktop.getFullscreen
        ?Boolean(await window.toyboxDesktop.getFullscreen())
        :!enabled;
      if(current!==enabled)await window.toyboxDesktop.toggleFullscreen();
    }else if(enabled&&!document.fullscreenElement){
      await document.documentElement.requestFullscreen();
    }else if(!enabled&&document.fullscreenElement){
      await document.exitFullscreen();
    }
  }catch{/* El sistema puede rechazar pantalla completa; se restaura el estado real. */}
  await refreshFullscreenSetting();
}

elements.settingsFullscreen.addEventListener('change',()=>setFullscreenState(elements.settingsFullscreen.checked));
elements.settingsGraphicsPreset.addEventListener('change',()=>{
  settings.graphics.preset=elements.settingsGraphicsPreset.value;
  applySettings();
});
const customGraphicsControls=[
  [elements.settingsRenderScale,'renderScale',Number],
  [elements.settingsShadowQuality,'shadowQuality',String],
  [elements.settingsParticleQuality,'particleQuality',String],
  [elements.settingsFpsLimit,'fpsLimit',Number],
];
customGraphicsControls.forEach(([control,key,convert])=>control.addEventListener('input',()=>{
  settings.graphics.preset='custom';
  settings.graphics[key]=convert(control.value);
  applySettings();
}));
elements.settingsShowFps.addEventListener('change',()=>{
  settings.graphics.showFps=elements.settingsShowFps.checked;
  applySettings();
});
document.addEventListener('fullscreenchange',refreshFullscreenSetting);
window.toyboxDesktop?.onFullscreenChanged?.((enabled)=>{
  elements.settingsFullscreen.checked=Boolean(enabled);
});

elements.localButton.addEventListener('click',()=>{audio.ensure();audio.uiBlip(240,.13,'sawtooth',.075);openLocal();});
elements.localBack.addEventListener('click',closeLocal);
elements.localModeList.addEventListener('click',(event)=>{
  const button=event.target.closest('[data-local-mode]');if(!button)return;
  selectLocalMode(button.dataset.localMode);
  audio.ensure();audio.uiBlip(285,.08,'triangle',.05);
});
elements.localBotDifficulty.addEventListener('click',(event)=>{
  const button=event.target.closest('[data-bot-difficulty]');if(!button)return;
  selectBotDifficulty(button.dataset.botDifficulty);
  audio.ensure();audio.uiBlip(305,.08,'triangle',.05);
});
elements.mapList.addEventListener('click',(event)=>{
  const button=event.target.closest('[data-map]');if(!button)return;
  selectLocalMap(button.dataset.map);
  audio.ensure();audio.uiBlip(270,.07,'triangle',.045);
});
elements.localStart.addEventListener('click',()=>{
  audio.ensure();audio.uiBlip(330,.17,'sawtooth',.09);
  startSelectedLocalMatch();
});
elements.practiceButton.addEventListener('click',()=>{
  audio.ensure();audio.uiBlip(190,.14,'sawtooth',.08);
  if(game.selectedMapId!==state.mapId)game.setMap(state.mapId);
  game.startPractice();
});
elements.tutorialButton.addEventListener('click',()=>{
  audio.ensure();audio.uiBlip(460,.16,'triangle',.085);
  if(game.selectedMapId!==state.mapId)game.setMap(state.mapId);
  game.startTutorial();
});
elements.testKoButton.addEventListener('click',()=>game.testPlayerElimination());
elements.accountButton.addEventListener('click',()=>{audio.ensure();audio.uiBlip(340,.08,'triangle',.045);openAccount();});
elements.accountBack.addEventListener('click',closeAccount);
elements.accountContinueGuest.addEventListener('click',closeAccount);
elements.accountLoginTab.addEventListener('click',()=>setAccountAuthMode('login'));
elements.accountRegisterTab.addEventListener('click',()=>setAccountAuthMode('register'));
elements.accountLoginForm.addEventListener('submit',(event)=>{
  event.preventDefault();
  if(!elements.accountLoginForm.reportValidity())return;
  runAccountAction(()=>playerAccount.signIn(
    elements.accountLoginEmail.value.trim(),
    elements.accountLoginPassword.value,
  ));
});
elements.accountRegisterForm.addEventListener('submit',(event)=>{
  event.preventDefault();
  const passwordsMatch=elements.accountRegisterPassword.value===elements.accountRegisterConfirm.value;
  elements.accountRegisterConfirm.setCustomValidity(passwordsMatch?'':'Las contraseñas no coinciden.');
  if(!elements.accountRegisterForm.reportValidity())return;
  runAccountAction(()=>playerAccount.signUp(
    elements.accountRegisterEmail.value.trim(),
    elements.accountRegisterPassword.value,
    elements.accountRegisterName.value.trim(),
  ));
});
elements.accountRegisterConfirm.addEventListener('input',()=>elements.accountRegisterConfirm.setCustomValidity(''));
elements.accountSaveProfile.addEventListener('click',()=>runAccountAction(async()=>{
  const profile=await playerAccount.updateDisplayName(elements.accountDisplayName.value);
  if(profile?.display_name&&!localStorage.getItem('toybox-online-name')){
    elements.onlinePlayerName.value=profile.display_name.slice(0,18);
  }
}));
elements.accountSyncNow.addEventListener('click',()=>runAccountAction(()=>playerAccount.refresh()));
elements.accountSignOut.addEventListener('click',()=>runAccountAction(()=>playerAccount.signOut()));
elements.garageOpen.addEventListener('click',()=>{audio.ensure();audio.uiBlip(300,.08,'triangle',.045);openGarage();});
elements.garageClose.addEventListener('click',()=>{audio.ensure();audio.uiBlip(250,.07,'triangle',.04);closeGarage();});
elements.garageSearch.addEventListener('input',()=>buildCarOptions(elements.garageSearch.value));
elements.carList.addEventListener('click',(event)=>{
  const button=event.target.closest('[data-car]');if(!button)return;
  const car=getCar(button.dataset.car);
  if(button.dataset.owned==='true')selectCar(car.id);
  else if(car.purchasable!==false)openPurchaseConfirmation(car,{kind:'vehicle',returnElement:button});
  audio.ensure();audio.uiBlip(320,.06,'square',.045);
});
elements.cosmeticTabs.addEventListener('click',(event)=>{
  const button=event.target.closest('[data-slot]');if(!button)return;
  state.cosmeticSlot=button.dataset.slot;updateSelectedCosmeticTab();renderCosmeticOptions();
  if(state.garageOpen)game.updateGaragePreview(state.carId,getCarLoadout(state.garage,state.carId),state.cosmeticSlot);
  audio.ensure();audio.uiBlip(370,.055,'triangle',.04);
});
elements.cosmeticList.addEventListener('click',(event)=>{
  const button=event.target.closest('[data-cosmetic]');if(!button)return;
  const item=getCosmeticItem(state.cosmeticSlot,button.dataset.cosmetic);
  if(button.dataset.owned==='true')selectCosmetic(item.id);
  else if(item.purchasable!==false)openPurchaseConfirmation(item,{slot:state.cosmeticSlot,returnElement:button});
  audio.ensure();audio.uiBlip(410,.065,'triangle',.045);
});
elements.purchaseConfirmAccept.addEventListener('click',confirmPendingPurchase);
elements.purchaseConfirmCancel.addEventListener('click',()=>closePurchaseConfirmation());
let garagePointerId=null;
let garagePointerX=0;
let garagePointerY=0;
elements.garagePreview.addEventListener('pointerdown',(event)=>{
  if(event.button!==0)return;
  garagePointerId=event.pointerId;garagePointerX=event.clientX;garagePointerY=event.clientY;
  elements.garagePreview.setPointerCapture(event.pointerId);
  elements.garagePreview.classList.add('dragging');
});
elements.garagePreview.addEventListener('pointermove',(event)=>{
  if(event.pointerId!==garagePointerId)return;
  game.orbitGarageCamera(event.clientX-garagePointerX,event.clientY-garagePointerY);
  garagePointerX=event.clientX;garagePointerY=event.clientY;
});
const releaseGaragePointer=(event)=>{
  if(event.pointerId!==garagePointerId)return;
  garagePointerId=null;elements.garagePreview.classList.remove('dragging');
};
elements.garagePreview.addEventListener('pointerup',releaseGaragePointer);
elements.garagePreview.addEventListener('pointercancel',releaseGaragePointer);
elements.garagePreview.addEventListener('wheel',(event)=>{event.preventDefault();game.zoomGarageCamera(event.deltaY);},{passive:false});
elements.garagePreview.addEventListener('dblclick',()=>game.resetGarageCamera());
elements.onlineButton.addEventListener('click',()=>{audio.ensure();audio.uiBlip(310,.12,'square',.06);openOnline();});
elements.onlineBack.addEventListener('click',closeOnline);
elements.onlineConnect.addEventListener('click',ensureOnlineConnection);
elements.onlineCreateRoom.addEventListener('click',async()=>{
  if(!await ensureOnlineConnection())return;
  online.createRoom({
    ...onlineIdentity(),
    mode:elements.onlineMode.value,
    mapId:elements.onlineMap.value,
    botDifficulty:elements.onlineBotDifficulty.value,
  });
});
elements.onlineQuickMatch.addEventListener('click',startQuickMatch);
elements.onlineJoinRoom.addEventListener('click',async()=>{
  const code=elements.onlineRoomCodeInput.value.trim().toUpperCase();
  if(code.length!==5){showOnlineError('Ingresá un código de sala de cinco caracteres.');return;}
  if(!await ensureOnlineConnection())return;
  online.joinRoom({code,...onlineIdentity()});
});
elements.onlineRoomCodeInput.addEventListener('input',()=>{
  elements.onlineRoomCodeInput.value=elements.onlineRoomCodeInput.value.toUpperCase().replace(/[^A-Z0-9]/g,'').slice(0,5);
});
elements.onlineRoomCodeInput.addEventListener('keydown',(event)=>{
  if(event.key==='Enter')elements.onlineJoinRoom.click();
});
elements.onlineMode.addEventListener('change',()=>{
  syncOnlineMapSelection();
  if(!online.room)elements.onlineMap.disabled=false;
  if(online.room?.hostId===online.playerId){
    online.configureRoom(
      elements.onlineMode.value,
      elements.onlineMap.value,
      elements.onlineBotDifficulty.value,
    );
  }
});
elements.onlineMap.addEventListener('change',()=>{
  if(elements.onlineMode.value==='rupture'){
    state.ruptureMapId=getRuptureMap(elements.onlineMap.value).id;
    localStorage.setItem('toybox-rupture-map',state.ruptureMapId);
  }
  if(online.room?.hostId===online.playerId){
    online.configureRoom(
      elements.onlineMode.value,
      elements.onlineMap.value,
      elements.onlineBotDifficulty.value,
    );
  }
});
elements.onlineBotDifficulty.addEventListener('change',()=>{
  selectBotDifficulty(elements.onlineBotDifficulty.value);
  if(online.room?.hostId===online.playerId){
    online.configureRoom(
      elements.onlineMode.value,
      elements.onlineMap.value,
      elements.onlineBotDifficulty.value,
    );
  }
});
elements.onlineReady.addEventListener('click',()=>{
  const me=online.room?.players.find((player)=>player.id===online.playerId);
  if(me){
    const identity=onlineIdentity();
    online.setReady(!me.ready,identity.carId,identity.loadout,identity.collider);
  }
});
elements.onlineStartMatch.addEventListener('click',()=>online.startMatch());
elements.onlineLeaveRoom.addEventListener('click',()=>{
  online.leaveRoom();
  automaticMatchmaking.cancel();
  if(automaticMatchmaking.isManagedConfigured){
    online.disconnect();
    renderOnlineConnection({
      status:'ready',
      detail:'Edgegap elegirá la región y levantará el servidor al buscar partida.',
    });
  }
  renderOnlineRoom(null,null);
});
elements.onlineCopyCode.addEventListener('click',async()=>{
  try{
    await navigator.clipboard.writeText(online.room?.code||'');
    elements.onlineCopyCode.textContent='COPIADO';
    setTimeout(()=>{elements.onlineCopyCode.textContent='COPIAR';},1100);
  }catch{showOnlineError('No se pudo copiar el código automáticamente.');}
});
elements.pauseButton.addEventListener('click',togglePause);
elements.resumeButton.addEventListener('click',()=>game.onlinePaused?game.pauseOnline(false):game.pause(false));
elements.restartButton.addEventListener('click',()=>game.restart());
const backToMainMenu=()=>{
  game.backToMenu();
  if(game.selectedMapId!==state.mapId)game.setMap(state.mapId);
};

function openExitConfirmation({title,copy,confirmLabel,action,returnFocus=null}){
  confirmedExitAction=action;
  exitConfirmReturnFocus=returnFocus||document.activeElement;
  state.exitConfirmOpen=true;
  elements.exitConfirmTitle.textContent=title;
  elements.exitConfirmCopy.textContent=copy;
  elements.exitConfirmAccept.textContent=confirmLabel;
  elements.exitConfirmation.classList.remove('hidden');
  input.clear();
  requestAnimationFrame(()=>focusInterfaceElement(elements.exitConfirmCancel));
}

function closeExitConfirmation({restoreFocus=true}={}){
  if(!state.exitConfirmOpen)return;
  state.exitConfirmOpen=false;
  confirmedExitAction=null;
  elements.exitConfirmation.classList.add('hidden');
  input.clear();
  const target=exitConfirmReturnFocus;
  exitConfirmReturnFocus=null;
  if(restoreFocus&&target?.isConnected)requestAnimationFrame(()=>focusInterfaceElement(target));
}

elements.exitConfirmCancel.addEventListener('click',()=>closeExitConfirmation());
elements.exitConfirmAccept.addEventListener('click',()=>{
  const action=confirmedExitAction;
  closeExitConfirmation({restoreFocus:false});
  action?.();
});
elements.backMenuButton.addEventListener('click',()=>{
  const onlineMatch=Boolean(game.onlineSession);
  openExitConfirmation({
    title:onlineMatch?'¿Salir de la partida online?':'¿Abandonar la partida?',
    copy:onlineMatch
      ?'Tu auto dejará la sala y volverás a la pantalla online.'
      :'Se perderá el progreso de esta partida y volverás al menú principal.',
    confirmLabel:onlineMatch?'SÍ, SALIR DE LA SALA':'SÍ, VOLVER AL MENÚ',
    action:onlineMatch?leaveOnlineGame:backToMainMenu,
    returnFocus:elements.backMenuButton,
  });
});
elements.resultsRestart.addEventListener('click',()=>{
  if(game.onlineSession)returnToOnlineRoom();
  else game.restart();
});
elements.resultsMenu.addEventListener('click',()=>{
  const onlineMatch=Boolean(game.onlineSession);
  openExitConfirmation({
    title:onlineMatch?'¿Volver a las salas online?':'¿Volver al menú principal?',
    copy:'Los resultados seguirán acá hasta que confirmes la salida.',
    confirmLabel:onlineMatch?'SÍ, VOLVER A SALAS':'SÍ, VOLVER AL MENÚ',
    action:onlineMatch?leaveOnlineGame:backToMainMenu,
    returnFocus:elements.resultsMenu,
  });
});
window.addEventListener('keydown',(event)=>{
  if(capturingBindingAction)return;
  const editable=isTextEntryElement(event.target)||event.target instanceof HTMLTextAreaElement;
  if(event.code==='Escape'){
    event.preventDefault();
    navigateInterfaceBack();
    return;
  }

  if(virtualKeyboardState){
    setInterfaceInputDevice('keyboard-mouse');
    if(event.code==='Backspace'){
      event.preventDefault();
      updateVirtualKeyboardInput(virtualKeyboardState.input.value.slice(0,-1));
      return;
    }
    if(event.code==='Enter'){
      event.preventDefault();
      closeVirtualKeyboard({accept:true});
      return;
    }
    if(event.key?.length===1&&!event.metaKey&&!event.ctrlKey&&!event.altKey){
      event.preventDefault();
      updateVirtualKeyboardInput(`${virtualKeyboardState.input.value}${event.key}`);
      return;
    }
  }

  const context=gamepadScreenContext();
  if(context==='game')return;
  if(event.code==='Tab'){
    setInterfaceInputDevice('keyboard-mouse');
    return;
  }
  if(editable){
    setInterfaceInputDevice('keyboard-mouse',{navigation:false});
    return;
  }

  if(state.garageOpen&&(event.code==='KeyQ'||event.code==='KeyE')){
    event.preventDefault();
    setInterfaceInputDevice('keyboard-mouse');
    cycleGarageCategory(event.code==='KeyE'?1:-1);
    return;
  }

  const directions={
    ArrowLeft:[-1,0],KeyA:[-1,0],
    ArrowRight:[1,0],KeyD:[1,0],
    ArrowUp:[0,-1],KeyW:[0,-1],
    ArrowDown:[0,1],KeyS:[0,1],
  };
  const direction=directions[event.code];
  if(direction){
    event.preventDefault();
    setInterfaceInputDevice('keyboard-mouse');
    moveGamepadFocus(...direction);
  }
},true);

elements.soundButton.addEventListener('click',()=>{state.muted=!state.muted;localStorage.setItem('toybox-muted',String(state.muted));audio.ensure();audio.setMuted(state.muted);elements.soundButton.classList.toggle('muted',state.muted);elements.soundButton.textContent=state.muted?'×':'♪';if(!state.muted)audio.uiBlip(360,.07,'sine',.05);});

elements.fullscreenButton.addEventListener('click',async()=>{
  if(window.toyboxDesktop){await window.toyboxDesktop.toggleFullscreen();}
  else if(!document.fullscreenElement){await document.documentElement.requestFullscreen();}else{await document.exitFullscreen();}
});

if(window.toyboxDesktop?.isElectron){
  elements.quitButton.classList.remove('hidden');
  elements.quitButton.addEventListener('click',()=>{
    openExitConfirmation({
      title:'¿Salir de The Turbo Crown?',
      copy:'Se cerrará el juego. Tu garage, configuración y progreso guardado no se perderán.',
      confirmLabel:'SÍ, CERRAR EL JUEGO',
      action:()=>window.toyboxDesktop.quit(),
      returnFocus:elements.quitButton,
    });
  });
}

buildCarOptions();buildCosmeticTabs();updateGarageCount();selectMap(state.mapId);selectLocalMode(state.localMode);selectBotDifficulty(state.botDifficulty);selectCar(state.carId);applySettings({persist:false});audio.setMuted(state.muted);audio.ensure();elements.soundButton.classList.toggle('muted',state.muted);elements.soundButton.textContent=state.muted?'×':'♪';
refreshFullscreenSetting();
setAccountAuthMode('login',{focus:false});
renderAccountState();
playerAccount.initialize(guestGarage,guestSelectedCarId);
updateGamepadNavigation();
game.renderFrame();
document.body.classList.remove('game-booting');

const launchParameters=new URLSearchParams(location.search);
const trailerScene=launchParameters.get('trailer');
const inspectionAngle = import.meta.env.DEV ? launchParameters.get('inspect') : null;
if(trailerScene==='impact'){
  elements.loading.classList.add('hidden');
  document.body.classList.add('trailer-director-mode');
  document.querySelectorAll('#app > :not(#game-canvas), #gamepad-focus-ring, #gamepad-hints').forEach((element)=>{
    element.classList.add('hidden');
  });
  const trailerDirector=new TrailerDirector(game,{
    carId:state.carId,
    loadout:game.selectedLoadout,
    initialTime:launchParameters.get('time'),
  });
  trailerDirector.start();
  window.trailerDirector=trailerDirector;
}else if (inspectionAngle) {
  elements.loading.classList.add('hidden');
  elements.menu.classList.add('hidden');
  game.mode='paused';
  game.world.group.visible=false;
  game.scene.fog=null;
  game.scene.background.set('#d9d7df');
  const menuInspection=inspectionAngle==='menu'||inspectionAngle==='menu-flat';
  game.showcaseCar.rotation.set(0,menuInspection?-.14:0,0);
  if(inspectionAngle==='menu-flat')game.sun.castShadow=false;
  const offsets={
    front:[3.2,1.65,-4.2],
    side:[4.8,1.35,0],
    rear:[-3.2,1.65,4.2],
    top:[3.2,4.6,-3.4],
    menu:[2.97,1.7,-3.58],
    'menu-flat':[2.97,1.7,-3.58],
  };
  const [x,y,z]=offsets[inspectionAngle]||offsets.front;
  const carPosition=game.showcaseCar.position;
  game.camera.position.set(carPosition.x+x,carPosition.y+y,carPosition.z+z);
  game.camera.lookAt(carPosition.x,carPosition.y+.48,carPosition.z);
  game.camera.fov=38;game.camera.updateProjectionMatrix();
} else {
  setTimeout(()=>{
    elements.loading.classList.add('done');
    elements.menu.classList.remove('hidden');
    setTimeout(()=>elements.loading.classList.add('hidden'),520);
  },850);
}
